export const patchNotes = {
  "15.32.3": {
    "date": "2026-11-04",
    "Features": [],
    "Bug Fixes": [
      "**agreement:** keep the product table visible at browser zoom",
      "**auth:** sync email from Slack on sign-in",
      "**organizations:** owner picker keeps the selected owner"
    ],
    "Style": [],
    "Refactors": []
  },
  "15.32.2": {
    "date": "2026-10-28",
    "Features": [],
    "Bug Fixes": [
      "**search:** serve /search/all from one prepared copy per index change"
    ],
    "Style": [],
    "Refactors": []
  },
  "15.32.1": {
    "date": "2026-10-09",
    "Features": [],
    "Bug Fixes": [
      "**new-business:** MRR is gross profit, not price"
    ],
    "Style": [],
    "Refactors": []
  },
  "15.32.0": {
    "date": "2026-10-09",
    "Features": [
      "**review:** show what a deal adds, and stop cutting the review page off"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "15.31.1": {
    "date": "2026-10-09",
    "Features": [],
    "Bug Fixes": [
      "**approvers:** every CSA goes to Creative, and website products reach the Website approver",
      "**approvers:** typing a name in Approver Settings no longer clears itself"
    ],
    "Style": [],
    "Refactors": []
  },
  "15.31.0": {
    "date": "2026-10-07",
    "Features": [
      "**accounts:** admins link the Heartbeat account, and Heartbeat supplies its name and NetSuite id",
      "**contracts:** show which template a deal's contract uses"
    ],
    "Bug Fixes": [
      "**contracts:** no signing links until the account is linked to Heartbeat",
      "**deploy:** pm2 only reads a config whose name contains .config.js",
      "**heartbeat-push:** renewals onto an empty ledger send their opening step, and the push log records what it sent",
      "**notifications:** an IO flight no longer hides an upsell from #tf-newbusiness",
      "**orgs,products:** index new orgs on write, stop products reverting, restore row drag",
      "**pandadoc:** revised deal types were shipping a literal [Organization Name]",
      "**reports:** find backend/ from the compiled script, not a fixed depth",
      "**reports:** the agreement alert posts on the second Tuesday"
    ],
    "Style": [],
    "Refactors": []
  },
  "15.30.0": {
    "date": "2026-09-11",
    "Features": [
      "**agreements:** add Status sort to the agreement product table",
      "**deals:** add a gross margin column to the payment schedule",
      "**deals:** show gross profit and media spend on the payment schedule",
      "**heartbeat:** stamp renewal or new business onto the contract we push",
      "**notifications:** #tf-newbusiness posts new business, not every deal won",
      "**notifications:** manage deal-notification recipients in the app",
      "**pandadoc:** let an organization override its contract template",
      "**reports:** monthly alert for agreements ending and expired"
    ],
    "Bug Fixes": [
      "**agreements:** drop the phantom scrollbar on the agreement sidebar",
      "**agreements:** keep the service table inside the viewport and scrollable",
      "**bulk-patch:** buffer numeric input + keep unresolved review rows distinct ([367a904](https://github.com/colin-cavanaugh-ob/grobotic/commit/367a9046a222b49ead18541ae2ac5834a1824447)), closes [#13](https://github.com/colin-cavanaugh-ob/grobotic/issues/13)",
      "**ci:** clear the lint errors blocking every PR",
      "**ci:** raise the heap for Build Check's frontend build",
      "**contracts:** stop internal agreements being sent, and retiring predecessors early",
      "**dates:** a calendar day now reads the same in every timezone",
      "**deals:** correct flighted-deal totals, invoicing impl fee, MSA monthly total",
      "**heartbeat:** correct scheduled MRR changes, product classification, and margin patches",
      "**heartbeat:** emit one submission per scheduled step, not one per direction ([66d0a76](https://github.com/colin-cavanaugh-ob/grobotic/commit/66d0a761a580ef895fe9d08d0f857b8a3b12ce46)), closes [#744](https://github.com/colin-cavanaugh-ob/grobotic/issues/744)",
      "**heartbeat:** name the content keys for the email that renders them",
      "**heartbeat:** run the version diff on a point-in-time MRR timeline",
      "**heartbeat:** send service_budget as a flat monthly fee (hours: 0) ([86d7461](https://github.com/colin-cavanaugh-ob/grobotic/commit/86d7461d9729dc1d6f34c32682e8917f29d6d169)), closes [#745](https://github.com/colin-cavanaugh-ob/grobotic/issues/745)",
      "**organizations:** stop the org grid crashing on null relationship entries",
      "**pandadoc:** include implementation fee in first month of contract payment schedule ([ed9a05b](https://github.com/colin-cavanaugh-ob/grobotic/commit/ed9a05b19de7022121a2b6d410595665a9166882)), closes [#15](https://github.com/colin-cavanaugh-ob/grobotic/issues/15)"
    ],
    "Style": [],
    "Refactors": []
  },
  "15.29.0": {
    "date": "2026-07-24",
    "Features": [
      "**agreements:** enable + correctly version no-signature agreements",
      "**bulk-patch:** filter picker to active orgs + strict parent labeling",
      "**bulk-patch:** redesign flow, active-org filter, strict parent labeling",
      "**heartbeat-pushes:** show re-pushed skips as Resolved",
      "**heartbeat-push:** self-healing predecessor history on Flow A",
      "**heartbeat-push:** stop sending subscriptions on Flow A (G1) ([19310d4](https://github.com/colin-cavanaugh-ob/grobotic/commit/19310d4599d3aeda3f665de58ad8b8c48fbd9a5b)), closes [#667](https://github.com/colin-cavanaugh-ob/grobotic/issues/667) [#667](https://github.com/colin-cavanaugh-ob/grobotic/issues/667)",
      "**heartbeat:** attach signed PandaDoc PDF to Grobotic contract pushes",
      "**heartbeat:** T3 driver — backfill-historical-contracts.ts",
      "**historical-import:** clamp pre-2026 GRO contracts to acquisition floor",
      "**payment-schedule:** implementation fee in first month + flighted monthly display"
    ],
    "Bug Fixes": [
      "**backfill:** only un-inflate submission MRR (reductions), hold increases",
      "**bootstrap:** stop dashboard data flashing then disappearing on load",
      "**bulk-patch:** collapsible sticky steps 2/3 + fill-height layout",
      "**heartbeat:** use monthly MRR for flighted + IO submissions",
      "**org-team:** stop \"[object Object]\" corruption of org team maps",
      "**org-totals:** count only active products in account metrics",
      "**pandadoc:** guardrails so link generation can't store broken links"
    ],
    "Style": [],
    "Refactors": []
  },
  "15.28.1": {
    "date": "2026-07-08",
    "Features": [],
    "Bug Fixes": [
      "**heartbeat:** report correct New Logo MRR on Grobotic contract pushes"
    ],
    "Style": [],
    "Refactors": [],
    "Performance Improvements": [
      "**deals:** KeepAlive pattern for deal tabs — visited tabs stay mounted"
    ]
  },
  "15.28.0": {
    "date": "2026-07-02",
    "Features": [
      "**bootstrap:** add /bootstrap/minimal endpoint + buildOnce timing logs",
      "**bootstrap:** add useMinimalShell hook stub for Phase 0 FE migration",
      "**bootstrap:** flip BootstrapData to block on useMinimalShell",
      "**bootstrap:** rewire useSearchData to call /search/minimal",
      "**dashboard:** subtle per-card loaders instead of a blocking full-page overlay",
      "**deals:** useDealData fetches by PK instead of pulling from global cache"
    ],
    "Bug Fixes": [
      "**bootstrap:** layer useSearchData — minimal first, full in background",
      "**bootstrap:** make SEARCH_DATA_KEY the primary cache that fills fast",
      "**bootstrap:** merge full+minimal per-field so detail data isn't lost",
      "**bootstrap:** project dealStatus + organizations into minimal payload",
      "**deals:** fetch parent org's custom products per-PK for margin auto-fill",
      "**deals:** patch + invalidate per-PK cache on optimistic save",
      "**deals:** route custom products through per-PK fetch end-to-end",
      "**deals:** Save and Update no longer silently aborts on no-signature contracts",
      "**deals:** sync product deltas into per-PK cache so payment schedule updates",
      "defensive guards on TeamsPage rows + RenderDealNameCell click"
    ],
    "Style": [],
    "Refactors": [
      "**bootstrap:** move minimal endpoint to /search/minimal"
    ],
    "Performance Improvements": [
      "**bootstrap:** use ProjectionExpression to collapse DDB pagination",
      "**deals:** share useDealData across tabs via context — fixes tab-switch lag",
      "**tabs:** wrap tab navigation in startTransition to eliminate mount flash"
    ]
  },
  "15.27.0": {
    "date": "2026-06-27",
    "Features": [
      "**heartbeat:** bulk linkage writeback + NetSuite triangulation probe"
    ],
    "Bug Fixes": [
      "**heartbeat-push:** tag trigger correctly for no-signature flow and dev button",
      "**monday:** move API key to env var and isolate Monday calls from Deal Won flow"
    ],
    "Style": [],
    "Refactors": []
  },
  "15.26.0": {
    "date": "2026-06-24",
    "Features": [
      "**deals:** bulk patch flow with auto-classify and multi-deal selection",
      "**heartbeat:** IO catalog grouping, Flow B no-contract gate, prospect-type reconciliation",
      "**heartbeat:** push log timeline + admin page + sparse GSI"
    ],
    "Bug Fixes": [
      "**ci:** exclude backend and broken smoke test from vitest discovery",
      "**ci:** keep devDependencies in backend install (tsc + tsc-alias are devDeps)",
      "**deals:** guard no-op patches and harden timeline + grid writes"
    ],
    "Style": [],
    "Refactors": [],
    "Performance Improvements": [
      "**ci:** consolidate jobs, cache node_modules, parallelize checks/builds/rsync"
    ]
  },
  "15.25.0": {
    "date": "2026-06-16",
    "Features": [
      "**deals:** add Gross Margin column to the Deals grid",
      "**heartbeat:** Grobotic ↔ Heartbeat contract submission flow",
      "**heartbeat:** NetSuite cross-reference + read-only DB tunnel",
      "**heartbeat:** preview tab, lineage footer, IO flow, sandbox fallback, dev push",
      "**heartbeat:** production launch fixes + CI hardening + reconciliation tooling",
      "**heartbeat:** production wiring + type-aware reconciliation tooling",
      "**orgs-grid:** inline edit + clear for NetSuite/Heartbeat fields (dev-gated)"
    ],
    "Bug Fixes": [
      "**heartbeat:** lazy-load native ssh2/pg to keep them out of cold boot"
    ],
    "Style": [],
    "Refactors": []
  },
  "15.24.0": {
    "date": "2026-06-09",
    "Features": [
      "**scripts:** Excel→MOTHERSHIP bulk import + contractedBy backfill"
    ],
    "Bug Fixes": [
      "**search:** include parent-org names in Deals + Products grid search"
    ],
    "Style": [],
    "Refactors": []
  },
  "15.23.0": {
    "date": "2026-06-04",
    "Features": [
      "**products:** Removed classification, GP / Prior GP / Parent Org columns"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "15.22.0": {
    "date": "2026-06-03",
    "Features": [
      "**deals:** Service Line classification, change-diff column, Gross Margin"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "15.21.0": {
    "date": "2026-06-02",
    "Features": [
      "**deals:** add Download Contract button to Heartbeat tab"
    ],
    "Bug Fixes": [
      "**deals:** correct NetSuite mapping for Programmatic Display + mgmt fees"
    ],
    "Style": [],
    "Refactors": []
  },
  "15.20.0": {
    "date": "2026-05-28",
    "Features": [
      "**deals:** add NetSuite Entry Reference to Heartbeat tab"
    ],
    "Bug Fixes": [
      "**ci:** refuse to ship dist with un-rewritten [@src](https://github.com/src) aliases"
    ],
    "Style": [],
    "Refactors": []
  },
  "15.19.1": {
    "date": "2026-05-27",
    "Features": [],
    "Bug Fixes": [
      "**pandadoc:** export getParentOrganization and harden backend build"
    ],
    "Style": [],
    "Refactors": []
  },
  "15.19.0": {
    "date": "2026-05-27",
    "Features": [
      "**pandadoc:** inject Parent Company token into template documents"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "15.18.1": {
    "date": "2026-05-21",
    "Features": [],
    "Bug Fixes": [
      "**batch-update:** resolve TDZ ReferenceError on wss in batch update route"
    ],
    "Style": [],
    "Refactors": []
  },
  "15.18.0": {
    "date": "2026-05-15",
    "Features": [
      "**notifications:** use gross profit for #tf-churn line-item breakdown"
    ],
    "Bug Fixes": [
      "**approvers:** use TABLES.GLOBAL_CONFIG instead of hardcoded table name",
      "**auth:** stop logging OAuth tokens and codes to the browser console",
      "**backend:** pin @img/sharp-linux-x64 as optional dep so it persists across deploys"
    ],
    "Style": [],
    "Refactors": []
  },
  "15.17.0": {
    "date": "2026-05-11",
    "Features": [
      "**deals,contracts:** remove clone/replace, fix amendment product bug, sync-products safety guard"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "15.16.0": {
    "date": "2026-05-06",
    "Features": [
      "**contracts,notifications:** saved sort order, churn MRR notification, sort fix"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "15.15.0": {
    "date": "2026-05-06",
    "Features": [
      "**contracts,scripts:** price/digital sort modes, sort-dirty detection, service line sync script",
      "**organizations:** state field autocomplete and normalization script"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "15.14.0": {
    "date": "2026-04-22",
    "Features": [
      "**contacts:** add deal/org tabs, fix grid, delete safety, owner update",
      "**deals,loop:** editable contacts on deal details, Loop icons and pricing"
    ],
    "Bug Fixes": [
      "**deals,contacts:** fix viewport scroll, autocomplete onChange, and grid cell cleanup",
      "**loop:** trigger Loop T&C when only Loop CallRail Integration is contracted",
      "**notifications:** add version to #tf-newbusiness and include DEAL_NOTIFICATION_IDS in webhook recipients",
      "**types:** cast custom theme palette keys to avoid TS2339 build errors"
    ],
    "Style": [],
    "Refactors": []
  },
  "15.13.0": {
    "date": "2026-04-13",
    "Features": [
      "**loop:** add Loop product tokens for PandaDoc conditional T&C",
      "**ui:** restyle deal/agreement components to match grobx layout"
    ],
    "Bug Fixes": [
      "**agreements:** preserve per-product dates when creating new deal version",
      "**deploy:** install @img/sharp-linux-x64 directly in CI pipeline",
      "**server:** catch malformed URI and CORS errors to prevent log flooding",
      "**time-tracker:** use TABLES.USER_ACTIVITY instead of hardcoded table name",
      "**timeline:** use TABLES.timeline instead of hardcoded table name"
    ],
    "Style": [],
    "Refactors": []
  },
  "15.12.0": {
    "date": "2026-04-09",
    "Features": [
      "**notifications:** add deal version to #tf-newbusiness channel posts",
      "**notifications:** add new user to deal-won notification recipients"
    ],
    "Bug Fixes": [
      "**deploy:** fix sharp platform binary installation in CI pipeline",
      "**deploy:** use npm install with --force for sharp linux-x64 binary",
      "**leads:** sort grid by submitted date descending, push empty dates to bottom"
    ],
    "Style": [],
    "Refactors": []
  },
  "15.11.3": {
    "date": "2026-04-02",
    "Features": [],
    "Bug Fixes": [
      "**leads-webhook:** write new leads to OBX_LEADS instead of hardcoded old table"
    ],
    "Style": [],
    "Refactors": []
  },
  "15.11.2": {
    "date": "2026-03-28",
    "Features": [],
    "Bug Fixes": [
      "**time-tracker:** fixed avatar rendering in time tracker component"
    ],
    "Style": [],
    "Refactors": []
  },
  "15.11.1": {
    "date": "2026-03-27",
    "Features": [],
    "Bug Fixes": [
      "**auth:** update .env.production with OuterBox Google + Slack + PandaDoc credentials",
      "**deploy:** add --omit-dir-times --no-perms to backend rsync",
      "**deploy:** add --omit-dir-times --no-perms to rsync to prevent permission errors",
      "**deploy:** exclude certificates, .env, node_modules, ecosystem.config from rsync delete",
      "**deploy:** relax lint/typecheck/test to non-blocking for production deploy",
      "**deploy:** update Node.js to 20.x for Vite compatibility",
      "**env-vars:** fixed ci/cd env vars"
    ],
    "Style": [],
    "Refactors": []
  },
  "15.11.0": {
    "date": "2026-03-27",
    "Features": [
      "**auth:** sync Slack profile data on every login — avatars, title, name, display name",
      "**churn:** add last day of service, gross profit, and contract value to churn notifications",
      "**churn:** detect client churn and notify #tf-churn when org has no remaining active deals",
      "**churn:** enhanced churn detection with date analysis and org status updates"
    ],
    "Bug Fixes": [
      "add single lead delete, pandadoc API key fallback, dev webhook route",
      "**connected-users:** fixed connected users avatar render",
      "**critical:** add resolveTableName to batch-requests.js getDynamoDB and getDynamoDBDirect",
      "**critical:** resolve table names in batch update array items and batchUpdatePkSkDynamoDB",
      "**slack:** update channel IDs to OuterBox workspace",
      "**types:** remove 'as const' from ROLES to fix .includes type errors"
    ],
    "Style": [],
    "Refactors": []
  },
  "15.10.0": {
    "date": "2026-03-26",
    "Features": [
      "**migration:** full OBX table migration — MOTHERSHIP, USERS_V2, centralized config"
    ],
    "Bug Fixes": [
      "**critical:** add resolveTableName to ALL DynamoDB operations",
      "**critical:** update sharedDataStore + search services to use TABLES config instead of hardcoded table names",
      "**server:** add resolveTableName import, CATALOG_TABLE, and table resolution middleware",
      "**tables-config:** updated codebase to use tables config for conditional table declarations"
    ],
    "Style": [],
    "Refactors": []
  },
  "15.9.3": {
    "date": "2026-03-26",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "**roles-notifications:** centralize roles config, update notification recipients and service integrations"
    ]
  },
  "15.9.2": {
    "date": "2026-03-26",
    "Features": [],
    "Bug Fixes": [
      "**deal-creation:** fixed error when creating deals on an organization with no current deals"
    ],
    "Style": [],
    "Refactors": []
  },
  "15.9.1": {
    "date": "2026-03-25",
    "Features": [],
    "Bug Fixes": [
      "**version-amendment:** margin can now be adjusted when making a major revision to deals"
    ],
    "Style": [],
    "Refactors": []
  },
  "15.9.0": {
    "date": "2026-03-25",
    "Features": [
      "**versioning:** align revision flows, enable product add/remove in amendment dialog"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "15.8.0": {
    "date": "2026-03-23",
    "Features": [
      "**agent-panel:** added prompt shortcuts for agent as well as a safety reference block to inform users on what prompts are currently utilized with the grobx agent"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "**ai-agent:** added system prompts to grobotic agent for better alignment in safety when running CRUD operations for different entities"
    ]
  },
  "15.7.0": {
    "date": "2026-03-23",
    "Features": [
      "**versioning:** deal lineage chain sorting, version labels, feature reference dialog, and build fixes"
    ],
    "Bug Fixes": [
      "**add-remove-product:** fixed bug when adding/removing products with a new revision, start date now editable in minor & major versions when revising active deals"
    ],
    "Style": [
      "**menu-bar:** repositioned menu items in floating nav bar, consolidated \"settings\" type items under on menu. Removed Heartbeat route for now. Refactored backfill script for deal versioning"
    ],
    "Refactors": []
  },
  "15.6.2": {
    "date": "2026-03-20",
    "Features": [],
    "Bug Fixes": [
      "**nosignature-webhook:** added webhook logic to correctly update nosignature deals when the deal is won"
    ],
    "Style": [],
    "Refactors": []
  },
  "15.6.1": {
    "date": "2026-03-20",
    "Features": [],
    "Bug Fixes": [
      "**org-grid-updates:** fixed error when updating team role assignments in org grid"
    ],
    "Style": [
      "**columns-style:** revised styling for agent chat panel, autosize added to global data grid for column width consistency"
    ],
    "Refactors": []
  },
  "15.6.0": {
    "date": "2026-03-13",
    "Features": [
      "**ai-agent:** introduced batch updating for patch and minor updates on deals"
    ],
    "Bug Fixes": [
      "**ai-agent-responses:** fixed agent responses to not imply that a contract is generated when a major version is being created. Added step selection for version change and major version information"
    ],
    "Style": [],
    "Refactors": []
  },
  "15.5.2": {
    "date": "2026-03-05",
    "Features": [],
    "Bug Fixes": [
      "**ai-agent-responses:** fixed agent responses to not imply that a contract is generated when a major version is being created. Added step selection for version change and major version information"
    ],
    "Style": [],
    "Refactors": []
  },
  "15.5.1": {
    "date": "2026-03-05",
    "Features": [
      "**heartbeat-integration, ui-polish:** Heartbeat sync service, pipeline docs, agent panel & header improvements"
    ],
    "Bug Fixes": [
      "**heartbeat-sync:** fixed issues with syncing grobotic --> heartbeat."
    ],
    "Style": [],
    "Refactors": []
  },
  "15.5.0": {
    "date": "2026-03-04",
    "Features": [
      "**ai-agent-panel:** version tab introduced in deal details, agent panel dock options added."
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "15.4.3": {
    "date": "2026-03-03",
    "Features": [],
    "Bug Fixes": [
      "**ai-agent:** fixed missing PK/SK from products"
    ],
    "Style": [],
    "Refactors": []
  },
  "15.4.2": {
    "date": "2026-03-03",
    "Features": [],
    "Bug Fixes": [
      "**payload-size:** optimized payload size for each message input to ai agent, added metric for payload size in development"
    ],
    "Style": [],
    "Refactors": []
  },
  "15.4.1": {
    "date": "2026-03-03",
    "Features": [],
    "Bug Fixes": [
      "**git-actions:** added new steps to staging.yml for more efficient build and deployment"
    ],
    "Style": [],
    "Refactors": []
  },
  "15.4.0": {
    "date": "2026-03-03",
    "Features": [
      "**ai-menus:** introduced more robust ai agent responses that include menus for selection to help efficiently query items without making excessive api calls. updated documentation of deals pipeline with the new versioning model"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "15.3.2": {
    "date": "2026-03-03",
    "Features": [],
    "Bug Fixes": [
      "**agent-markdown:** fixed errors for nested elements in agent markdown, updated deals pipeline markdown and revised style for <strong> elements rendered by ai agent"
    ],
    "Style": [],
    "Refactors": []
  },
  "15.3.1": {
    "date": "2026-03-03",
    "Features": [],
    "Bug Fixes": [
      "**product-status/loader:** fixed product statuses being recalculated even when a deal is ended by agent for a new version replacement. Removed excess overlay rendered for loader in navbar"
    ],
    "Style": [],
    "Refactors": []
  },
  "15.3.0": {
    "date": "2026-03-03",
    "Features": [
      "**localdb-reports-ui:** localdb integration from main project, reports dashboard, grid loading overlay, centralized DynamoDB clients"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "15.2.4": {
    "date": "2026-03-02",
    "Features": [],
    "Bug Fixes": [
      "**versioning-aiagent:** optimized ai logic to match the versioning logic in the deals pipeline more efficiently. created backfill scripts for legacy deals that do not contain versions. Node chaining introduced for versioning and deal lineage render updated to account for this."
    ],
    "Style": [],
    "Refactors": []
  },
  "15.2.3": {
    "date": "2026-03-02",
    "Features": [],
    "Bug Fixes": [
      "**versioning-localdb:** optimized versioning for deals pipeling, added safety check for localdb"
    ],
    "Style": [],
    "Refactors": []
  },
  "15.2.2": {
    "date": "2026-03-02",
    "Features": [],
    "Bug Fixes": [
      "**org-profile:** fixed social icons render in org profile, revised pythons scripts to better update deal status and product statuses, ai agent can now product monthly revenue by organization"
    ],
    "Style": [],
    "Refactors": []
  },
  "15.2.1": {
    "date": "2026-03-01",
    "Features": [],
    "Bug Fixes": [
      "**ai-server-clientdata:** optimized the chat inputs to not send data via clientData, instead use cached data on the server side to keep input size more consistent and efficient"
    ],
    "Style": [],
    "Refactors": []
  },
  "15.2.0": {
    "date": "2026-03-01",
    "Features": [
      "**ai-agent:** popout window, markdown exports, server-side grid and agent improvements"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "15.1.0": {
    "date": "2026-02-28",
    "Features": [
      "**ai-agent-menus:** added product, organization and deal menu items to the ai agent, click the rendered chips below the input to toggle lists for reference"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "15.0.1": {
    "date": "2026-02-28",
    "Features": [],
    "Bug Fixes": [
      "**ai-querying:** fixed ai-agent requests to backend, was using full table scans for related deals and orgs, now using querying to O)"
    ],
    "Style": [
      "**ai-agent:** changed icon for ai agent to anthropic logo"
    ],
    "Refactors": []
  },
  "15.0.0": {
    "date": "2026-02-28",
    "Features": [
      "**ai-agent, deal-versioning:** AI agent chat panel with deal creation, version history lineage in deal info cards, and semantic versioning across contracts"
    ],
    "Bug Fixes": [],
    "Style": [
      "**ai-agent, deal-versioning:** Introduces AI agent integration for deal creation and organization lookup. Deals now support semantic versioning with automatic lineage tracking. Agent can create versioned deals with product pricing carried forward. DealInfoCard displays full version history chain with clickable navigation. Agent service backfills versioning fields on pre-existing deals. Added remark-gfm for proper markdown table rendering in agent chat. Theme updates for new UI components."
    ],
    "Refactors": []
  },
  "14.27.0": {
    "date": "2026-02-27",
    "Features": [
      "**deal-versioning:** active contract detection added to create deal and agreement details in deals. When creating a deal on an organization with existing contracts, the logic will require you to select the type of change you are making. Depending on this change, the logic will create a new \"version\" of the deal or a completely new deal entirely. server: added agent controller, system-prompts, services and tools for anthropic-sdk integration prototype. The AI agent currently can search for existing orgs and if they have attached deals, and also create a new deal based on that information."
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "14.26.5": {
    "date": "2026-02-27",
    "Features": [],
    "Bug Fixes": [
      "**create-deal:** fixed: deal data is correctly reset when the agreement options switch back and forth, without removing selected organization"
    ],
    "Style": [],
    "Refactors": []
  },
  "14.26.4": {
    "date": "2026-02-27",
    "Features": [],
    "Bug Fixes": [
      "**create-deal:** fixed: when switching between deal agreement options the selected deal will no longer stay selected if the agreement option is switched to New/Add-on Business"
    ],
    "Style": [],
    "Refactors": []
  },
  "14.26.3": {
    "date": "2026-02-27",
    "Features": [],
    "Bug Fixes": [
      "**create-deal:** use useSyncSelectedContacts and allContacts merge in CreateNewDeal"
    ],
    "Style": [
      "**obx-theme:** new theme added: obxops"
    ],
    "Refactors": []
  },
  "14.26.2": {
    "date": "2026-02-26",
    "Features": [],
    "Bug Fixes": [
      "**frontend-ts-fixes:** resolved all ts errors during frontend build"
    ],
    "Style": [],
    "Refactors": []
  },
  "14.26.1": {
    "date": "2026-02-25",
    "Features": [
      "**orgs+agreements:** add Google Ads ID column and PandaDoc audit trail"
    ],
    "Bug Fixes": [
      "**server-ts-errors:** fixed ts errors when building backend for production. Pipeline flow charts created for mermaid.live of deals pipeline"
    ],
    "Style": [],
    "Refactors": []
  },
  "14.26.0": {
    "date": "2026-02-22",
    "Features": [
      "**agreements:** add master agreement versioning with cumulative semantic versions"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "14.25.0": {
    "date": "2026-02-17",
    "Features": [
      "**dev-staging-gate:** developer staging gate added to dev server"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "14.24.0": {
    "date": "2026-02-17",
    "Features": [
      "add staging environment configuration steps",
      "add staging environment variables for frontend",
      "enable staging deployment workflow",
      "implement professional CI/CD pipeline with GitHub Actions"
    ],
    "Bug Fixes": [
      "add staging environment configuration for backend",
      "deploy to staging even if tests fail",
      "frontend build errors for staging deployment",
      "improve staging deployment workflow",
      "increase Node.js heap size for frontend build",
      "make SSL config conditional and correct build output dir for CI",
      "make staging workflow truly non-blocking for lint/test errors",
      "**nginx-env:** fixed nginx and staging env vars",
      "require frontend build to succeed before deployment",
      "skip type checking in staging build",
      "upgrade Node.js to 20.x for Vite compatibility and make frontend build non-blocking",
      "upload artifacts even if tests fail",
      "use base64-encoded SSH key to preserve formatting"
    ],
    "Style": [],
    "Refactors": []
  },
  "14.23.8": {
    "date": "2026-02-16",
    "Features": [],
    "Bug Fixes": [
      "update all relative imports to use path aliases"
    ],
    "Style": [],
    "Refactors": [
      "**backend:** migrate to path aliases and consolidate route handlers",
      "consolidate application directories into src/"
    ]
  },
  "14.23.7": {
    "date": "2026-02-12",
    "Features": [],
    "Bug Fixes": [
      "**deals-nosignature:** fixed completed internally deals not being able to create contracts"
    ],
    "Style": [
      "**deals:** dealinfo card updated layout, contract icon link is now included in the agreement tab separate from the rendered data"
    ],
    "Refactors": []
  },
  "14.23.6": {
    "date": "2026-02-12",
    "Features": [],
    "Bug Fixes": [
      "**products:** fix: select deals products list not rendering properly, issue was duplicate product_uuids which is a deprecated reference, updated to reference the correct SK on each product."
    ],
    "Style": [
      "**deal-comparison:** added version numbers to deal comparison modal",
      "**themes:** removed filler background in datagrids for more consistent styling on pinned columns"
    ],
    "Refactors": []
  },
  "14.23.5": {
    "date": "2026-02-10",
    "Features": [],
    "Bug Fixes": [
      "**accounting:** fixed: action on deal name not responding"
    ],
    "Style": [],
    "Refactors": []
  },
  "14.23.4": {
    "date": "2026-02-09",
    "Features": [],
    "Bug Fixes": [
      "**organizations:** added indexing for organizations when updating for efficient data rendering"
    ],
    "Style": [
      "**scrollbar:** revised scrollbar global styles and data grid scrollbar styles"
    ],
    "Refactors": []
  },
  "14.23.3": {
    "date": "2026-02-09",
    "Features": [],
    "Bug Fixes": [
      "**affiliate-update-list/floating-bar-styles:** fixed populated list when inline updating affiliate organization and updated styling for floating nav buttons"
    ],
    "Style": [],
    "Refactors": []
  },
  "14.23.2": {
    "date": "2026-02-09",
    "Features": [],
    "Bug Fixes": [
      "**org-grid/websocket:** Fixed: Affiliated column not included in search queries, user image not displayed in connected users list in quick chat drawer"
    ],
    "Style": [],
    "Refactors": []
  },
  "14.23.1": {
    "date": "2026-02-09",
    "Features": [],
    "Bug Fixes": [
      "**mtb-approvers:** updated approvers grid with newer components, optimized mtb rendering"
    ],
    "Style": [],
    "Refactors": []
  },
  "14.23.0": {
    "date": "2026-02-06",
    "Features": [
      "**timetracker:** add team member filtering and UI improvements"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "14.22.5": {
    "date": "2026-02-06",
    "Features": [],
    "Bug Fixes": [
      "**comments:** fixed missing comment counts from MTB and NCO"
    ],
    "Style": [],
    "Refactors": []
  },
  "14.22.4": {
    "date": "2026-02-04",
    "Features": [],
    "Bug Fixes": [
      "**deals:** migrate ViewAgreement to useDealEditingMachine and fix deal sync persistence"
    ],
    "Style": [],
    "Refactors": []
  },
  "14.22.3": {
    "date": "2026-02-04",
    "Features": [],
    "Bug Fixes": [
      "**grids:** cache invalidation, sorting fixes, server-side search improvements, and bulk import tooling"
    ],
    "Style": [
      "**nav-bar-styling:** simplified and modernized nav bar styling"
    ],
    "Refactors": []
  },
  "14.22.2": {
    "date": "2026-02-03",
    "Features": [],
    "Bug Fixes": [
      "**server:** updated webhook config to fix approval url in slack notification as well as monthly totals for new business notifications"
    ],
    "Style": [],
    "Refactors": []
  },
  "14.22.1": {
    "date": "2026-02-03",
    "Features": [],
    "Bug Fixes": [
      "**nco-updates:** fixed inline status updates for nco and onboarding task overflow config"
    ],
    "Style": [],
    "Refactors": []
  },
  "14.22.0": {
    "date": "2026-02-03",
    "Features": [
      "**inline-updates:** inline single and mass update improvements with bug fixes"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "14.21.1": {
    "date": "2026-02-03",
    "Features": [],
    "Bug Fixes": [
      "**org-fixes-styling:** fixed sorting issues with data grids, simplified styling for scroll bars due to rendering issues."
    ],
    "Style": [],
    "Refactors": [
      "**search-hook-grid-prototype:** created grid prototype for migration over to mass inline and single inline updating"
    ]
  },
  "14.21.0": {
    "date": "2026-01-30",
    "Features": [
      "**organizations:** add inline editing and mass update for organizations grid"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "14.20.0": {
    "date": "2026-01-30",
    "Features": [
      "**quick-chat:** add browser tab notification for new messages"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "14.19.1": {
    "date": "2026-01-30",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "**quick-chat:** rename Quick Messages to Quick Chat"
    ]
  },
  "14.19.0": {
    "date": "2026-01-30",
    "Features": [
      "**quick-messages:** add online/offline indicators and hide test mode in production"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "14.18.0": {
    "date": "2026-01-30",
    "Features": [
      "**quick-messages:** add prototype real-time chat feature for connected users"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "**auth-server-logs:** refactored authentication logs to display when a user is authenticated without the unnecessary response information"
    ]
  },
  "14.17.3": {
    "date": "2026-01-30",
    "Features": [],
    "Bug Fixes": [
      "**mtb-nco:** fixed footer rendering and filter model consistency. Added role columns for each organization"
    ],
    "Style": [],
    "Refactors": []
  },
  "14.17.2": {
    "date": "2026-01-30",
    "Features": [],
    "Bug Fixes": [
      "**grid:** restore footer with filters and row counts in NCO/MTB grids"
    ],
    "Style": [],
    "Refactors": []
  },
  "14.17.1": {
    "date": "2026-01-30",
    "Features": [],
    "Bug Fixes": [
      "**loading-server-refactor:** deleted unused files from server directories and consolidated to src/ updated loading for review deal"
    ],
    "Style": [],
    "Refactors": []
  },
  "14.17.0": {
    "date": "2026-01-30",
    "Features": [
      "**google-ads:** add Python script for organization name matching"
    ],
    "Bug Fixes": [
      "**cache:** improve cache sync for comments, tasks, deals and organizations"
    ],
    "Style": [],
    "Refactors": []
  },
  "14.16.0": {
    "date": "2026-01-29",
    "Features": [
      "**activity-tracker:** enhance Chrome extension with per-account tracking and DOM extraction"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "14.15.0": {
    "date": "2026-01-29",
    "Features": [
      "**activity-tracker:** add name-based matching for Google Ads accounts"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "**contacts,nco:** reorganize imports and simplify visibility model"
    ]
  },
  "14.14.0": {
    "date": "2026-01-29",
    "Features": [
      "**google-ads:** fix API integration with new GCP project credentials"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "14.13.1": {
    "date": "2026-01-29",
    "Features": [],
    "Bug Fixes": [
      "**google-ads:** improve error handling and display actual API error messages"
    ],
    "Style": [],
    "Refactors": []
  },
  "14.13.0": {
    "date": "2026-01-29",
    "Features": [
      "**google-ads:** add Google Ads API integration with OAuth flow"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "**server-logs:** refactored server files to reduce verbose logging"
    ]
  },
  "14.12.0": {
    "date": "2026-01-28",
    "Features": [
      "**deals:** add real-time search index sync and fix deal deletion"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "14.11.0": {
    "date": "2026-01-28",
    "Features": [
      "**organizations:** add role-based team member management"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "14.10.0": {
    "date": "2026-01-27",
    "Features": [
      "**health:** replace bootstrap health badge with search index health monitoring"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "14.9.0": {
    "date": "2026-01-27",
    "Features": [
      "**data-layer:** consolidate entity update hooks and add developer documentation"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "14.8.0": {
    "date": "2026-01-27",
    "Features": [
      "**search:** complete migration to search-based data with optimistic updates"
    ],
    "Bug Fixes": [
      "**chrome-extension:** update API URL to production port 2096"
    ],
    "Style": [],
    "Refactors": []
  },
  "14.7.0": {
    "date": "2026-01-26",
    "Features": [
      "**search:** add SharedDataStore and server-side pagination for MTB/NCO grids"
    ],
    "Bug Fixes": [
      "**changelog:** fix parsing of commit links leaving trailing parentheses"
    ],
    "Style": [],
    "Refactors": []
  },
  "14.6.1": {
    "date": "2026-01-26",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "**products:** products option added to board nav and theme color added"
    ],
    "Refactors": [
      "**backend:** migrate routes to src/routes directory structure"
    ]
  },
  "14.6.0": {
    "date": "2026-01-23",
    "Features": [
      "**grid-products-filters:** products, organizations and deals grids now use server side pagination, filtering and sorting. Date range filters introduced to products grid. Aggregation is still being optimized"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "14.5.0": {
    "date": "2026-01-23",
    "Features": [
      "**server-organizations:** organizations now using pagination and server side filtering, sorting.."
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "14.4.1": {
    "date": "2026-01-22",
    "Features": [],
    "Bug Fixes": [
      "**extension/grobotic-activity-tracker:** Tracker accessible without authentication now and will be accessible to users pending review from google"
    ],
    "Style": [],
    "Refactors": []
  },
  "14.4.0": {
    "date": "2026-01-21",
    "Features": [
      "**agreements-taskupdates:** sorting now available on deal agreements and row updates for tasks fixed for assignees and queue. Assigning someone to the queue field will send them a notification\\*\\*\\*"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "14.3.1": {
    "date": "2026-01-21",
    "Features": [],
    "Bug Fixes": [
      "**extension:** updates to authentication"
    ],
    "Style": [],
    "Refactors": []
  },
  "14.3.0": {
    "date": "2026-01-20",
    "Features": [
      "**legal:** add Chrome extension privacy policy page"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "14.2.1": {
    "date": "2026-01-20",
    "Features": [],
    "Bug Fixes": [
      "**types:** resolve TypeScript build errors across multiple files"
    ],
    "Style": [],
    "Refactors": []
  },
  "14.2.0": {
    "date": "2026-01-20",
    "Features": [
      "**activity-tracker:** add Chrome extension for tracking Google Ads time"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "14.1.2": {
    "date": "2026-01-20",
    "Features": [],
    "Bug Fixes": [
      "**directories-org:** fixed rendering of connected data when attempting to delete an organization, large refactor of leads, mtb, deals, organizations, nco, projects and teamtasks. All grid related components live in their related directories"
    ],
    "Style": [],
    "Refactors": [
      "**deals-directories:** major refactor and consolidation of deals directories",
      "**shared-directory:** shared directory started and some files already consolidated"
    ]
  },
  "14.1.1": {
    "date": "2026-01-19",
    "Features": [],
    "Bug Fixes": [
      "**ui-state:** fixed issues when navigating using board navigation menu, popover now cleans up ui state properly before navigating"
    ],
    "Style": [],
    "Refactors": []
  },
  "14.1.0": {
    "date": "2026-01-19",
    "Features": [
      "**accounting/teams:** new teams grid introduced to display all team members and provide navigation to profiles using image. Integrated standardized drawer components for accounting grid/drawer"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "14.0.8": {
    "date": "2026-01-19",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "14.0.7": {
    "date": "2026-01-17",
    "Features": [],
    "Bug Fixes": [
      "**mtb:** fixed routing for comment cell in mtb grid"
    ],
    "Style": [],
    "Refactors": []
  },
  "14.0.6": {
    "date": "2026-01-17",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "**mtb:** major refactor of MTB, NCO, and theme components"
    ]
  },
  "14.0.5": {
    "date": "2026-01-16",
    "Features": [],
    "Bug Fixes": [
      "**nco-mtb:** fixed and optimized nco loading, updates still needed for mtb drawer"
    ],
    "Style": [],
    "Refactors": []
  },
  "14.0.4": {
    "date": "2026-01-15",
    "Features": [],
    "Bug Fixes": [
      "**deals:** real-time WebSocket sync and version tracking for deals"
    ],
    "Style": [],
    "Refactors": []
  },
  "14.0.3": {
    "date": "2026-01-15",
    "Features": [],
    "Bug Fixes": [
      "**release-notes:** fixed release notes rendering and virtualization for list"
    ],
    "Style": [],
    "Refactors": []
  },
  "14.0.2": {
    "date": "2026-01-15",
    "Features": [],
    "Bug Fixes": [
      "**nco:** resolve slow drawer rendering and unnecessary API calls on close"
    ],
    "Style": [],
    "Refactors": [
      "**autocomplete:** EntityAutocomplete.tsx and useEntityAutocomplete hook introduced",
      "**mtb-nco:** new tab navigation and drawer wrapper components introduced",
      "**nco-mtb:** removed unused files and components from nco and mtb directories",
      "**visualization:** deals hierarchy visualization",
      "**visualization:** refactored UI_COMPONENTS_MAP.md for deals hierarchy visualization"
    ]
  },
  "14.0.1": {
    "date": "2026-01-15",
    "Features": [],
    "Bug Fixes": [
      "**version-control:** updated and fixed rendering for patch notes"
    ],
    "Style": [],
    "Refactors": []
  },
  "14.0.0": {
    "date": "2026-01-15",
    "Features": [],
    "Bug Fixes": [
      "Build system migrated from CRA/CRACO to Vite -replaced react-scripts with Vite -Updated build configuration -Fixed MUI Datagrid rendering issues post-migration - cleaned up and optimized theme files -Added shared theme utilities",
      "feat!: frontend migration from create react app to vite"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.35.1": {
    "date": "2026-01-15",
    "Features": [],
    "Bug Fixes": [
      "**datagrid-background:** fixed background covering datagrid cells/rows from themes"
    ],
    "Style": [],
    "Refactors": [
      "**deals-columns:** refactored the deals columns to use EntityAvatar component for owner, this enables the image with a clickable url to the users profile and shows their name upon hover via tooltip"
    ]
  },
  "13.35.0": {
    "date": "2026-01-14",
    "Features": [
      "**user-profile:** user profiles introduced, user images will link to a user profile page. Read only when viewing others, but can edit phone and social urls when viewing their own."
    ],
    "Bug Fixes": [
      "**time-tracker:** fixed task activity not being logged in report"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.34.0": {
    "date": "2026-01-14",
    "Features": [
      "**time-tracker:** time-tracker components introduced for all users"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "13.33.0": {
    "date": "2026-01-14",
    "Features": [
      "**leads:** inline-updating added, as well as slack notifications and grobotic notifications"
    ],
    "Bug Fixes": [],
    "Style": [
      "**page-container:** revised height values for components using PageContainer.tsx. More revisions needed for other components"
    ],
    "Refactors": []
  },
  "13.32.0": {
    "date": "2026-01-13",
    "Features": [
      "**server-tracker:** changes made to server: added api endpoints for user-activity and created new table USER_ACTIVITY with two GSIs for activity analytics. Frontend test component added to review activity"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "13.31.0": {
    "date": "2026-01-13",
    "Features": [
      "**time-tracker:** time tracker introduced globally to track via navigation and specific areas of application"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "**profile:** new profile and related components created to centralize components needing to render profiles. These components will help migrate all entities displaying profile type information"
    ]
  },
  "13.30.2": {
    "date": "2026-01-12",
    "Features": [],
    "Bug Fixes": [
      "**tagging/org-routing:** fixed errors when tagging in task comments / fixed routing when navigating to organization from the task header"
    ],
    "Style": [
      "**version-control:** styling for Version.tsx updated"
    ],
    "Refactors": [
      "**organizations:** introduced global header component for entities in application",
      "**routing:** new components created for tab routing and page containers for all item"
    ]
  },
  "13.30.1": {
    "date": "2026-01-12",
    "Features": [],
    "Bug Fixes": [
      "**approvals-server:** added loading state for approvers and global approvals workflow, validation added before request can be successfully made and debug logging. Fixed WebSocket undefined error in server.ts"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.30.0": {
    "date": "2026-01-12",
    "Features": [
      "**team-tasks:** added custom filtering for postdated tasks in team tasks grid, fixed organizations with only pending products not showing up in org list when creating tasks."
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "**deals:** started refactor for profile, details, infocard and routing components for deals. These components will then be used for other entities in the app to render their profile, details etc.."
    ]
  },
  "13.29.4": {
    "date": "2026-01-09",
    "Features": [],
    "Bug Fixes": [
      "**approvals:** fixed approvers not being properly assigned upon requesting approval for IO"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.29.3": {
    "date": "2026-01-09",
    "Features": [],
    "Bug Fixes": [
      "**batch-tasks/tasks-grid:** fixed paid search not displaying types in batch task creation, added column orders and reset column order button to all grids"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.29.2": {
    "date": "2026-01-09",
    "Features": [],
    "Bug Fixes": [
      "**tasks-grid:** fixed routing for name, contracted by and organizations column cells in team tasks & projects"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.29.1": {
    "date": "2026-01-09",
    "Features": [],
    "Bug Fixes": [
      "**lint:** fixed lint errors, optimizing/fixing lint warnings next"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.29.0": {
    "date": "2026-01-09",
    "Features": [
      "**tasks:** reset column order button added to all grid (currently only ready in team tasks, background color added to postdated tasks"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "13.28.0": {
    "date": "2026-01-09",
    "Features": [
      "**tasks:** column order added to team tasks, as well as post dated column and editing. Assigner added to task drawer details. When a task is created a new \"details\" field is available for extra context on the task. This data will render in a separate column in the grid to provide more detailed information on the task without changing the current task names"
    ],
    "Bug Fixes": [],
    "Style": [
      "**theme:** revised createAppTheme to leverage existing themes for consistency"
    ],
    "Refactors": []
  },
  "13.27.2": {
    "date": "2026-01-08",
    "Features": [],
    "Bug Fixes": [
      "**theme-leads:** fixed themeproviders to correctly apply the correct theme based on selection, fixed leads not giving an additional popover when deleting a lead"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.27.1": {
    "date": "2026-01-08",
    "Features": [],
    "Bug Fixes": [
      "**products-sync:** revised useSyncProducts to patch cache directly instead of an entire refetch of main table when saving and updating products. removed problematic qc.removeQueries call for the main KEY for bootstrap data that was causing blank states"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.27.0": {
    "date": "2026-01-08",
    "Features": [
      "**organizations-profile:** tree data added to rendered child organizations inside parent orgs, when a child org is rendered, it will list the parent orgs with their rolled up totals"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "13.26.0": {
    "date": "2026-01-08",
    "Features": [
      "**organization-profile:** totals for both parent and child organizations added to grids rendered in the organizations tab in OrganizationProfile.tsx"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "13.25.0": {
    "date": "2026-01-08",
    "Features": [
      "**organizations:** organizations tab added to organizations profile page"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "13.24.2": {
    "date": "2026-01-08",
    "Features": [],
    "Bug Fixes": [
      "**server:** fixed errors with server build before pushing to production"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.24.1": {
    "date": "2026-01-08",
    "Features": [],
    "Bug Fixes": [
      "fixed style issues for agreements page in deals, updated screen size responsiveness"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.24.0": {
    "date": "2026-01-07",
    "Features": [
      "**deals:** progress tracker and ui feedback added to updating/saving in agreements in deals"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "**deals-phase01:** phase 01 complete, optimizations for all save functionality",
      "**deals-phase0203:** optimized calculations for deals in useDealData, refactored and added websocket connections for real time updates in frontend and backend",
      "**deals-phase06:** Phase 06 complete, updated ui and using all new changes to synchronize deal updates",
      "**deals-phase06:** visual feedback, editing, porgress panel with step labels during save, success / error with auto dismiss, immediate UI updated before server confirms, automatic rollback on failure, progress tracking from orchestrator. Integrated into ViewAgreement.tsx",
      "**optimize-deals-phase04:** step-based execution of deal updates, progress tracking, error handling, concurrent save prevention, two new apis: useSaveDealOrchestrator and useDealQuickSave"
    ]
  },
  "13.23.1": {
    "date": "2026-01-07",
    "Features": [],
    "Bug Fixes": [
      "**dom-fix:** fixed DOM errors in MtbPage and OrgDealInfo"
    ],
    "Style": [
      "style changes to leads footer",
      "**style-optimization:** centralized component styling for buttons, caards, containers, dialogs, forms, info-sections, scrollbars, textfields and typography",
      "**style-refactor:** major refactor of theme provider, converted to typescript and centralized styling as well as global components created"
    ],
    "Refactors": [
      "**typescript-conversion:** all frontend files converted to typescript successfully and compiled without typescript errors",
      "**typescript-dispersion:** removed types.ts from src/ and added src/types, this directory now contains logical groupings of types in separate files for better readability"
    ]
  },
  "13.23.0": {
    "date": "2026-01-05",
    "Features": [
      "**leads:** new columns added: status, quality and assigned to. These columns can be updated by selecting a row or mass updated by selecting multiple rows"
    ],
    "Bug Fixes": [],
    "Style": [
      "**optimizations:** updated styling for leads.tsx and added status, quality and assignedTo columns. Accounting margins now displayed in each drawer"
    ],
    "Refactors": [
      "**optimizations:** optimized backend deleting most unused files and completely deleting unused dist/ directory, modified some frontend files as well",
      "**optimizations:** server.js converted to typescript and new packages installed. Old packages removed. deleted old or duplicate js files from backend"
    ]
  },
  "13.22.8": {
    "date": "2026-01-04",
    "Features": [],
    "Bug Fixes": [
      "**optimization:** optimized NCOPage loading and efficiency"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.22.7": {
    "date": "2026-01-04",
    "Features": [],
    "Bug Fixes": [
      "**optimizations:** lint issues optimized and reconfigured, deleted unused files and optimized organizationspage"
    ],
    "Style": [],
    "Refactors": [
      "**src/types:** moved types for organizations_table into separate file declarations"
    ]
  },
  "13.22.6": {
    "date": "2026-01-02",
    "Features": [],
    "Bug Fixes": [
      "**nco-page:** optimized grid tree persistence with stable state. Optimized formatting of deals and tree rows in both buildDealTreeRows and NCOPage"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.22.5": {
    "date": "2025-12-23",
    "Features": [],
    "Bug Fixes": [
      "**approvers:** optimized determining approvers on load of agreements"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.22.4": {
    "date": "2025-12-23",
    "Features": [],
    "Bug Fixes": [
      "**approvals:** fixed incorrect products array being"
    ],
    "Style": [],
    "Refactors": [
      "**server-approval-url:** fixed .env file to contain the correct DOMAIN_URL definition for when a deal is fully approved. The link should now be correct"
    ]
  },
  "13.22.3": {
    "date": "2025-12-23",
    "Features": [],
    "Bug Fixes": [
      "fixed value calculations for margin / media spend / payer fields when products change or are newly added"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.22.2": {
    "date": "2025-12-23",
    "Features": [],
    "Bug Fixes": [
      "**agreements:** optimized product syncing with server to no longer clear live data while editing. State after save refactored to detect changes more efficiently and clear changes after save more efficiently"
    ],
    "Style": [],
    "Refactors": [
      "removed unnecessary console.log from components"
    ]
  },
  "13.22.1": {
    "date": "2025-12-23",
    "Features": [],
    "Bug Fixes": [
      "**custom-products:** fixed error in useDealData hook accessing productRows too early"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.22.0": {
    "date": "2025-12-23",
    "Features": [
      "**custom-products:** when adding or changing products to a product listed in the parent organizations custom products, the margin and price will auto fill with the values set for the organization by default. autofocus added to the products autocomplete"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "13.21.0": {
    "date": "2025-12-23",
    "Features": [
      "**custom-products:** indicate archived and selected options in autocomplete | reuse archived custom product values when reselected"
    ],
    "Bug Fixes": [],
    "Style": [
      "final revisions to data grid containers for consistency"
    ],
    "Refactors": [
      "refactored logic for parent client custom products"
    ]
  },
  "13.20.3": {
    "date": "2025-12-22",
    "Features": [],
    "Bug Fixes": [
      "fixed all grids for consistent height and logic for flex height / padding"
    ],
    "Style": [
      "updated styling for update panel in nco"
    ],
    "Refactors": []
  },
  "13.20.2": {
    "date": "2025-12-22",
    "Features": [],
    "Bug Fixes": [
      "fixed routing issues for NCO and updated drawer context for efficiency"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.20.1": {
    "date": "2025-12-22",
    "Features": [],
    "Bug Fixes": [
      "fixed product PK SK mismatch in invoicing for deals"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.20.0": {
    "date": "2025-12-22",
    "Features": [
      ": add persistent last-selected row highlight"
    ],
    "Bug Fixes": [],
    "Style": [
      "navigation backdrop filter and text color applied for task attachments, comments now have a max height so it is easier to view pasted attachments but using the thumbnails"
    ],
    "Refactors": []
  },
  "13.19.3": {
    "date": "2025-12-22",
    "Features": [],
    "Bug Fixes": [
      "attachment viewers will no longer close the task drawer or navigate to other tasks while viewer is open. arrow keys will navigate through attachments and esc will close the attachment viewer only"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.19.2": {
    "date": "2025-12-22",
    "Features": [],
    "Bug Fixes": [
      "fixed old localstorage filters breaking functionality for deals"
    ],
    "Style": [],
    "Refactors": [
      "new automated testing for route components, lint config revised for efficiency, unused file removal begins"
    ]
  },
  "13.19.1": {
    "date": "2025-12-19",
    "Features": [],
    "Bug Fixes": [
      "fixed eslint missing imports"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.19.0": {
    "date": "2025-12-19",
    "Features": [
      "custom product selection for to define top level margins and pricing now available in parent organizations. After selected and saved, the margin and price for each product will show up as a list for deals that are created in relation to this organization."
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactor for tasks column render, added Name_Cell.tsx for more efficient rendering and removed child nodes from task rows"
    ]
  },
  "13.18.1": {
    "date": "2025-12-18",
    "Features": [],
    "Bug Fixes": [
      "cleanup server side logs for authentication"
    ],
    "Style": [
      "fixed stuttering and menu issues when task list for creation is large"
    ],
    "Refactors": [
      "refactored global settings for eslint to auto remove unused imports"
    ]
  },
  "13.18.0": {
    "date": "2025-12-18",
    "Features": [
      "batch task creation will only contain active products/deals during selection, product menu will no longer get cut off when making many tasks at once, more efficient styling for both organization and product autocomplete"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactored batch task creation for more efficient styling. after selecting an organization will only render active deals/products in the option selection"
    ]
  },
  "13.17.2": {
    "date": "2025-12-18",
    "Features": [],
    "Bug Fixes": [
      "fixed routing to affiliated orgs"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.17.1": {
    "date": "2025-12-18",
    "Features": [],
    "Bug Fixes": [
      "fixed row error for affiliated cell in org grid"
    ],
    "Style": [
      "revised column visibility for deals in organization details"
    ],
    "Refactors": [
      "refactored deals and org columns for efficiency, updated rendered columns for deals inside organization details"
    ]
  },
  "13.17.0": {
    "date": "2025-12-17",
    "Features": [
      "Datagrids added to products, deals and contacts for organization details. Parent organizations rollup their related data and aggregate values"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "13.16.2": {
    "date": "2025-12-17",
    "Features": [],
    "Bug Fixes": [
      "fixed tab routing for organizations details, updated products table to use the data grid"
    ],
    "Style": [
      "fixed display for search index and org name reference and updated rendering",
      "style fixes to parent and child rows in organizations page"
    ],
    "Refactors": []
  },
  "13.16.1": {
    "date": "2025-12-17",
    "Features": [],
    "Bug Fixes": [
      "fixed filtering for task boards to include assignees when filtering for unique tasks"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.16.0": {
    "date": "2025-12-16",
    "Features": [
      "parent organization data refactored server side to roll up all values for efficient rendering and calculations in parent orgs. Contacts tab added to organiztions profile. Totals added to parent organizations"
    ],
    "Bug Fixes": [],
    "Style": [
      "search index now hidden from organizations grid"
    ],
    "Refactors": []
  },
  "13.15.4": {
    "date": "2025-12-15",
    "Features": [],
    "Bug Fixes": [
      "when navigating using data grid rows in tasks, comments will update with the correct list"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.15.3": {
    "date": "2025-12-15",
    "Features": [],
    "Bug Fixes": [
      "fixed flickering in grid footers during data sync and new websocket connections"
    ],
    "Style": [
      "more subtle styling for snackbars"
    ],
    "Refactors": []
  },
  "13.15.2": {
    "date": "2025-12-15",
    "Features": [],
    "Bug Fixes": [
      "updated projects page state for consistent drawer rendering"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.15.1": {
    "date": "2025-12-15",
    "Features": [],
    "Bug Fixes": [
      "team tasks and projects task drawers should now render with much more stability. When editing the task the server side data syncing should not interrupt frontend functionality or rendering."
    ],
    "Style": [],
    "Refactors": [
      "refactor drawer provider for efficiency, reworking debugging for syncing issues"
    ]
  },
  "13.15.0": {
    "date": "2025-12-12",
    "Features": [
      "added debug context for efficient logging of rerenders and remounting"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "13.14.10": {
    "date": "2025-12-11",
    "Features": [],
    "Bug Fixes": [
      "refactored task components for more efficient syncing when tasks are being updated"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.14.9": {
    "date": "2025-12-11",
    "Features": [],
    "Bug Fixes": [
      "added more columns for products analysis"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.14.8": {
    "date": "2025-12-11",
    "Features": [],
    "Bug Fixes": [
      "updated status_report.py, efficiency for organization grid rendering"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.14.7": {
    "date": "2025-12-09",
    "Features": [],
    "Bug Fixes": [
      "updated server.js webhook function to correctly assign Viewed for statuses when the contract has been viewed. Updated status_report.py"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.14.6": {
    "date": "2025-12-08",
    "Features": [],
    "Bug Fixes": [
      "small updates for packages being used, versioning audit created"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.14.5": {
    "date": "2025-11-26",
    "Features": [],
    "Bug Fixes": [
      "deal details now show correct totals for CSA's - per payment total added"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.14.4": {
    "date": "2025-11-24",
    "Features": [],
    "Bug Fixes": [
      "CSA totals now display properly in grid columns and inside agreements"
    ],
    "Style": [
      "changed placeholder for text editor",
      "placement for tooltips optimized in comment card for editing and deleting"
    ],
    "Refactors": []
  },
  "13.14.3": {
    "date": "2025-10-29",
    "Features": [],
    "Bug Fixes": [
      "optimizations now display their name as an identifier in the comments section of the MTB when an optimization is selected"
    ],
    "Style": [
      "fixed padding and margins for task selector and TextEditor for more efficient rendering in drawer components"
    ],
    "Refactors": []
  },
  "13.14.2": {
    "date": "2025-10-29",
    "Features": [],
    "Bug Fixes": [
      "fixed org and contracted by column values logic"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.14.1": {
    "date": "2025-10-29",
    "Features": [],
    "Bug Fixes": [
      "integration tab will now render for all users"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.14.0": {
    "date": "2025-10-29",
    "Features": [
      "comment count column added to accounting columns, column widths optimized and style for text overflow updated"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "13.13.6": {
    "date": "2025-10-29",
    "Features": [],
    "Bug Fixes": [
      "fixed webhook logic to skip contracted by if there is none attached so notifications and flow are not interrupted"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.13.5": {
    "date": "2025-10-29",
    "Features": [],
    "Bug Fixes": [
      "optimized server logs for bootstrap data"
    ],
    "Style": [
      "avatar size and density style efficiency for organizations grid"
    ],
    "Refactors": []
  },
  "13.13.4": {
    "date": "2025-10-28",
    "Features": [],
    "Bug Fixes": [
      "optimized organization columns, removed creation_timestamp from initial render and adjusted widths"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.13.3": {
    "date": "2025-10-28",
    "Features": [],
    "Bug Fixes": [
      "optimized mtb and organizations column rendering"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.13.2": {
    "date": "2025-10-28",
    "Features": [],
    "Bug Fixes": [
      "fixed descriptions not updating when they are the only update made to the product. Will update efficiently when edited solo or together with other field values"
    ],
    "Style": [
      "background color to data grid cells changes for light theme"
    ],
    "Refactors": [
      "refactored orgproducts to render a product info card on click instead of navigating nowhere"
    ]
  },
  "13.13.1": {
    "date": "2025-10-27",
    "Features": [],
    "Bug Fixes": [
      "fixed header messages for different task assignments ie. assignee | active assignee"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.13.0": {
    "date": "2025-10-27",
    "Features": [
      "notifications for created tasks introduced"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "13.12.15": {
    "date": "2025-10-27",
    "Features": [],
    "Bug Fixes": [
      "fixed accounting drawer open state to utilize routing"
    ],
    "Style": [
      "fixed icon button height for all nav items",
      "removed background color for custom overlay"
    ],
    "Refactors": []
  },
  "13.12.14": {
    "date": "2025-10-27",
    "Features": [],
    "Bug Fixes": [
      "fixed mtb drawer staying open upon unmount, big style changes to dark and light themes"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.12.13": {
    "date": "2025-10-27",
    "Features": [],
    "Bug Fixes": [
      "fixed undefined query function for dev environment and more efficient querying for bootstrap query hook"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.12.12": {
    "date": "2025-10-24",
    "Features": [],
    "Bug Fixes": [
      "added parent organization and organization name to webhook for slack when deal is won"
    ],
    "Style": [],
    "Refactors": [
      "major refactor of shared cache logic on server side. /bootstrap endpoint optimized to keep more data synced during invalidation and to only invalidate when needed. force invalidate button working as expected now"
    ]
  },
  "13.12.11": {
    "date": "2025-10-24",
    "Features": [],
    "Bug Fixes": [
      "added more helpers for keeping fresh data without refreshing browser, sync-products endpoint updated so far"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.12.10": {
    "date": "2025-10-24",
    "Features": [],
    "Bug Fixes": [
      "org name now included with new business payload for notification to new business channel in slack"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.12.9": {
    "date": "2025-10-24",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactored server side endpoint /bootstrap for more efficient invalidation and background fetching. Added more functions for utility."
    ]
  },
  "13.12.8": {
    "date": "2025-10-22",
    "Features": [],
    "Bug Fixes": [
      "added filter operators to nco columns rendering to fix any issues when using custom filters with views / native filters"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.12.7": {
    "date": "2025-10-22",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "optimized overflow cells in deals grid to display ellipsis instead of clipping"
    ],
    "Refactors": []
  },
  "13.12.6": {
    "date": "2025-10-22",
    "Features": [],
    "Bug Fixes": [
      "fixed nco default filter model to filter out launched and bypass grid items"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.12.5": {
    "date": "2025-10-22",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactored nco column rendering for optimized loading and reduce latency"
    ]
  },
  "13.12.4": {
    "date": "2025-10-22",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "more consistent global styling using paper component and select background colors for menu items defined globally"
    ],
    "Refactors": []
  },
  "13.12.3": {
    "date": "2025-10-22",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactored integrations fields to update using save / edit mode, added new component to organization page so editing is also available on account ids for organizations"
    ]
  },
  "13.12.2": {
    "date": "2025-10-21",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "more padding around statuses in nco && task grids"
    ],
    "Refactors": []
  },
  "13.12.1": {
    "date": "2025-10-21",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "revised column widths for NCO and new active column for optimized rendering"
    ],
    "Refactors": []
  },
  "13.12.0": {
    "date": "2025-10-21",
    "Features": [
      "NCO grid will now display an Active column for the current team that should be working on the onboard, based on the task list progress inside the NCO drawer"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "13.11.0": {
    "date": "2025-10-21",
    "Features": [
      "notifications introduced for batch updates to task grids, these include projects and team tasks, when an active assignee is updated for multiple tasks, one notification is sent informing the team member that they were assigned and links will be provided for each task they were assigned to."
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "13.10.1": {
    "date": "2025-10-21",
    "Features": [],
    "Bug Fixes": [
      "fixed tagging inconsistency when images or gifs are copy and pasted to the body of the comment"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.10.0": {
    "date": "2025-10-21",
    "Features": [
      "leads table now using globaldatagrid"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "13.9.8": {
    "date": "2025-10-21",
    "Features": [],
    "Bug Fixes": [
      "fixed sorting in NCO grid for comment counts, using numeric sort operator"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.9.7": {
    "date": "2025-10-21",
    "Features": [],
    "Bug Fixes": [
      "fixed rendering of comments inside NCO drawer, component: Drawer_NCO"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.9.6": {
    "date": "2025-10-20",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactored invalidate bootstrap hook to remove Etag for efficient refetching and refreshing of server side data"
    ]
  },
  "13.9.5": {
    "date": "2025-10-20",
    "Features": [],
    "Bug Fixes": [
      "fixed products not being created correctly in contracts, syncing is now more efficient and websocket create, update and delete events added for products. Revised server side bootstrap endpoint to invalidate more efficiently when products are created and the force invalidation button is clicked"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.9.4": {
    "date": "2025-10-17",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "fixed save button rendering based on equality of current team vs new team"
    ],
    "Refactors": []
  },
  "13.9.3": {
    "date": "2025-10-17",
    "Features": [],
    "Bug Fixes": [
      "contracted by column displays name only in MTB, fixed team updates for mtb and nco not syncing correctly"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.9.2": {
    "date": "2025-10-17",
    "Features": [],
    "Bug Fixes": [
      "fixed inconsistent rendering for when a deal is resolved"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.9.1": {
    "date": "2025-10-16",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "added close icon button to DRAWER_NCO"
    ],
    "Refactors": []
  },
  "13.9.0": {
    "date": "2025-10-16",
    "Features": [
      "team editing introduced to MTB, this will change the organizations team when assigned differently. close icon button added to the drawer"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "13.8.3": {
    "date": "2025-10-16",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "updated context filters in commentsinput to display the correct identifier when inputting comments in different locations of the app"
    ]
  },
  "13.8.2": {
    "date": "2025-10-16",
    "Features": [],
    "Bug Fixes": [
      "fixed rendering of assignees for tasks in nco drawer"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.8.1": {
    "date": "2025-10-16",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "refactored styling for approvers in review deal based on density, smaller sizes inside drawers and standard size for deal tab"
    ],
    "Refactors": []
  },
  "13.8.0": {
    "date": "2025-10-16",
    "Features": [
      "task selector now displays correct tasks for NCO comments, comments are only editable by their owner. NCO Task list can be created by deal owner & PM. SEO and Integrations checklists can only be edited by a team member in that role."
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "13.7.5": {
    "date": "2025-10-16",
    "Features": [],
    "Bug Fixes": [
      "fixed webhook attached to gro contact form on gromarketing.com. fixed deletion in leads, can now delete a single lead and not just multiple leads. Fixed task type rendering for different products in batch selection when creating tasks"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.7.4": {
    "date": "2025-10-16",
    "Features": [],
    "Bug Fixes": [
      "refactored editcontactinfo and contactdetails for efficient updates and rendering"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.7.3": {
    "date": "2025-10-16",
    "Features": [],
    "Bug Fixes": [
      "assigning organizations to contacts revised for easier readability",
      "fixed zindex for popover when deleting tasks"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.7.2": {
    "date": "2025-10-15",
    "Features": [],
    "Bug Fixes": [
      "assigning organizations to contacts revised for easier readability"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.7.1": {
    "date": "2025-10-15",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "default column widths for optimizations grid"
    ],
    "Refactors": []
  },
  "13.7.0": {
    "date": "2025-10-14",
    "Features": [
      "optimizations grid added, refactor to server bootstrap cache to optimize loading times and allow for background fetching"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "13.6.5": {
    "date": "2025-10-14",
    "Features": [],
    "Bug Fixes": [
      "revised removeRow function and removed nested setAllItems state dispatcher, refactoring useDealData for efficiency for next steps"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.6.4": {
    "date": "2025-10-13",
    "Features": [],
    "Bug Fixes": [
      "fixed drag and drop for product rows in deal contract"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.6.3": {
    "date": "2025-10-13",
    "Features": [],
    "Bug Fixes": [
      "fixed deal list when replacing current deal to only allow selection of deals that are not currently queued up for replacement"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.6.2": {
    "date": "2025-10-13",
    "Features": [],
    "Bug Fixes": [
      "fixed billing status update bug for accounting grid. Loading overlay added to accounting, nco and team tasks grid"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.6.1": {
    "date": "2025-10-13",
    "Features": [],
    "Bug Fixes": [
      "fixed vertical rendering for create new deal and org autocomplete list"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.6.0": {
    "date": "2025-10-13",
    "Features": [
      "feat: add team update in grid",
      "enable mass update for team_details alongside status/contractedBy/tracking",
      "support single-row team edit from Organizations grid",
      "cache + websocket invalidation for updated team members"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "13.5.3": {
    "date": "2025-10-10",
    "Features": [],
    "Bug Fixes": [
      "fixed draft state for contracts being completed internally"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.5.2": {
    "date": "2025-10-10",
    "Features": [],
    "Bug Fixes": [
      "fixed revert to draft status inconsistency by using the panda contract status directly"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.5.1": {
    "date": "2025-10-10",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactored mtb drawer and nco drawer and added icons for different user roles based on tab rendering. Reintroduced products as child rows for total metrics to mtb grid."
    ]
  },
  "13.5.0": {
    "date": "2025-10-09",
    "Features": [
      "MTB and NCO updated with new tab structure, rows are accessible while drawer is open to navigate through grid without having to close. Routing updated. Styling for containers updated based on new vertical structure"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "13.4.2": {
    "date": "2025-10-09",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "revised opacity for when drawers are opened to better highlight rows that are clickable to navigate through"
    ],
    "Refactors": []
  },
  "13.4.1": {
    "date": "2025-10-08",
    "Features": [],
    "Bug Fixes": [
      "fixed tab routing efficiency"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.4.0": {
    "date": "2025-10-08",
    "Features": [
      "mtb drawer now using new tab structure for items in mtb grid. Fixed updates for when commments are read to sync cache correctly and not invalidate org_table"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "13.3.2": {
    "date": "2025-10-07",
    "Features": [],
    "Bug Fixes": [
      "updates persisting channels and clientIntro now for kickoff call doc"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.3.1": {
    "date": "2025-10-07",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "replaced default buttons with custom in kickoff call component"
    ],
    "Refactors": []
  },
  "13.3.0": {
    "date": "2025-10-07",
    "Features": [
      "kickoff call refactored and successfully creates new google doc. save logic added to this tab so you can save the doc info and org info before creating"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "13.2.12": {
    "date": "2025-10-07",
    "Features": [],
    "Bug Fixes": [
      "fixed cache syncing when updating contracts and ensured consistent totals across the deal components. On save the deals totals object is updated"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.2.11": {
    "date": "2025-10-07",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactored bootstrap server api to greatly optimize formatting for deals and products, reducing load times for contracts and lag when editing contracts"
    ]
  },
  "13.2.10": {
    "date": "2025-10-07",
    "Features": [],
    "Bug Fixes": [
      "removed complex formatting from useEntitiesFromAllItems hook to fix bugs in contracts for deals"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.2.9": {
    "date": "2025-10-07",
    "Features": [],
    "Bug Fixes": [
      "fixed heavy lag in organizations grid"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.2.8": {
    "date": "2025-10-06",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactored task drawer to correctly close when clicking outside of the drawer into the empty grid, can also close using the top right X and esc key"
    ]
  },
  "13.2.7": {
    "date": "2025-10-06",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "placeholder updated for empty description in task drawer"
    ],
    "Refactors": []
  },
  "13.2.6": {
    "date": "2025-10-06",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "fixed height issues with timeline in task drawer"
    ],
    "Refactors": []
  },
  "13.2.5": {
    "date": "2025-10-06",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "fixed deal tab in organizations to stretch full height of container, added scrolling in grid view inside drawer for team tasks and projects"
    ],
    "Refactors": []
  },
  "13.2.4": {
    "date": "2025-10-06",
    "Features": [],
    "Bug Fixes": [
      "fixed white screen when accessing nco item without a team and team ids array"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.2.3": {
    "date": "2025-10-06",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "efficient spacing for filters when multiple are needed - dashboardpage.tsx"
    ],
    "Refactors": []
  },
  "13.2.2": {
    "date": "2025-10-06",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "added color to rendered value filter select"
    ],
    "Refactors": []
  },
  "13.2.1": {
    "date": "2025-10-06",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "added more filters to deals and tasks lists in dashboard, added dealStatus to rendered secondary of list items for deals"
    ],
    "Refactors": []
  },
  "13.2.0": {
    "date": "2025-10-05",
    "Features": [
      "filter selection added to task list in dashboard"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "13.1.7": {
    "date": "2025-10-04",
    "Features": [],
    "Bug Fixes": [
      "fixed orgs without images not rendering anything"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.1.6": {
    "date": "2025-10-04",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "added org images to rendered list items for better identification"
    ],
    "Refactors": []
  },
  "13.1.5": {
    "date": "2025-10-04",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactored logic to correctly render when user is task owner or assigner"
    ]
  },
  "13.1.4": {
    "date": "2025-10-04",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "added more conditional colors to rendered types, boards and text"
    ],
    "Refactors": []
  },
  "13.1.3": {
    "date": "2025-10-04",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "added better month & type filtering for tasks in dashboard"
    ],
    "Refactors": []
  },
  "13.1.2": {
    "date": "2025-10-03",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "updated routing for dashboard page"
    ]
  },
  "13.1.1": {
    "date": "2025-10-03",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "added panel labels to dashboard for admin and user"
    ],
    "Refactors": []
  },
  "13.1.0": {
    "date": "2025-10-03",
    "Features": [
      "New Dashboard layout, metrics and data"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "13.0.9": {
    "date": "2025-10-03",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactored useEntities hook to format data more efficiently and use consistent totals for all deals"
    ]
  },
  "13.0.8": {
    "date": "2025-10-03",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "removed tagged by users from rendered display below the comment, moved read by to the end of the container displayed in an avatar group with tooltip"
    ]
  },
  "13.0.7": {
    "date": "2025-10-03",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "removed download / delete overlay directly above task attachments, introduced tooltip for more efficiency"
    ],
    "Refactors": []
  },
  "13.0.6": {
    "date": "2025-10-02",
    "Features": [],
    "Bug Fixes": [
      "fixed scrollToView in comment cards when editing posted comments"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.0.5": {
    "date": "2025-10-02",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactored image upload and delete react query hooks, task drawer and comments input + task messages using consistent data source for tasks and comments"
    ]
  },
  "13.0.4": {
    "date": "2025-10-02",
    "Features": [],
    "Bug Fixes": [
      "fixed DBA/Legal Entity Name render in agreement"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.0.3": {
    "date": "2025-10-02",
    "Features": [],
    "Bug Fixes": [
      "dealinfo card using correct totals hook and function"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.0.2": {
    "date": "2025-10-02",
    "Features": [],
    "Bug Fixes": [
      "centralized totals object for all deals to useDealData, deals totals are now consistent"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.0.1": {
    "date": "2025-10-02",
    "Features": [],
    "Bug Fixes": [
      "number of payments set to 1 and read only if deal is less than 2500"
    ],
    "Style": [],
    "Refactors": []
  },
  "13.0.0": {
    "date": "2025-10-02",
    "Features": [
      "added bootstrap health button for metrics on last cache invalidation and to test timing during work hours",
      "added cache timer to tooltip over the grobotic logo in top left, timer represents table data expiry timer for reference",
      "added feedback when deleting subtasks from tasks, insights now have a date range to choose instead of a follow up date, save icon for assignees simplified",
      "added new notification to webhook, newbusiness channel will receive a deal won notification with the deal name and total value",
      "batch delete added to leads table",
      "big refactor of organizations grid, new table ORGANIZATIONS_TABLE single dynamoDB design with organizations, deals, products in one",
      "big updates to creating tasks and progress inside mtb, month is determined and if no tasks are created the logic will create new tasks and progress for that month, single and batch updates working efficiently",
      "boards menu order is now customizable by drag and drop",
      "checklist now auto creating based on creative task chosen, editable fields to be rendered next",
      "create new deal added and updated, timelines refactored for deals",
      "Deals comments now available, optimizations made for accounting grid and mtb rendering",
      "density selector added, refactored toolbar for dynamic use in different grid components",
      "dynamic filtering in monthly task board, selecting a month will display aggregate totals and when you type in a search for a specific value, the totals will change based on the rows returned",
      "Editing now available in task drawer, task layout changed. uploaded attachments and images more efficiently rendered in task drawer footer",
      "inside the task drawer in team tasks, assignees can be saved using the check icon after making changes, this will immediately save and update the task",
      "leasing percentage now an option available when creating optimizations in mtb",
      "major refactor of agreements tab, reassigning and updating recipients now functioning correctly, need to update cache upon update successful. UI change detection introduced",
      "major refactor of contracts functionality, new edit and save view modes,",
      "monthly filter will now show different totals for every month of the year, including past and future months. This will show totals for monthly contract amount and monthly media spend, this also removes rows not containing those months",
      "mtb grid comments now introduced",
      "New batch create for tasks to simplify task management",
      "New DataGrids added to all boards, aggregation will be included for columns, more customizations will be added",
      "new drawer feature added for extra fields need in batch creation, Integration Services - Hourly product added to database",
      "new endpoint server side for bootstrap loading and bootstrap health, cache will be used by all connected users and cache health can be viewed by hovering over the grobotic logo, greatly increases efficiency, reduces cost and greatly reduces stress on server",
      "new feature for creating organization level tasks in creating batch tasks",
      "NEW FEATURE: when using the Clone deal feature, users can change the organization and it will still duplicate the deal that was selected for cloning but replace the deals organization details with the new organization selected. This only works for cloning only, not for clone and replace",
      "new month filtering inside the monthly task board, progress and tasks will be filtered to the current month by default",
      "new search bar added to top navigation, use click or ctrl + shift + F to",
      "new server side endpoints for creating progress items in monthly task board, seo, am, dms and overall progress tracking correctly",
      "new typescript components for org datagrid",
      "new user settings options added to header for app, updating gmail signature now available inside user settings.",
      "new views setup for monthly task board",
      "optimizations now dictate status availability based on the monthly task associated",
      "organizations now using pagination for grid",
      "pasting into rich text editor will now upload images after posting and also attach them to the comment. Styling greatly revised for efficiency",
      "pinned rows now rendering in NCO based on staging deal stage, creating task list and starting onboarding changes stage to onboarding and removes from pinned list, styling fixes and server fix to update date won when contract is fully completed",
      "product rows now available in organizations table",
      "read receipts added to mtb",
      "refactored and added new selections for batch task creation",
      "row selection added to batch creation of tasks, when a row is selected the drawer will render with extra fields to be edited, the radio button can be used while the drawer is open to navigate between rows and edit different tasks without closing the drawer",
      "SEO checklist now creating based on tier and the jotform link is included, progress will track for the checklist as well",
      "seo progress updating correctly",
      "testing batch task creation on a separate route and page",
      "tree data reintroduced to organizations grid, export will format headers, org names and some cell values and include the related products nested with their organizations if they are active currently",
      "updated dashboard page to include products, organizations, deals and tasks",
      "updated read receipts to only be triggered when the comment is not owned by the current user, light indicator for unread comments",
      "updates to active assignee working for mtb, uses team that is assigned in organizations for the assignee list",
      "updates to MTB for efficiency, tasks are created automatically when the organization is accessed inside the mtb, progress will be recreated every month when accessed as well",
      "updates to team reintroduced to mtb, this will update the organizations data as well, the organizations team and mtb team are the same data currently",
      "when creating tasks, description is now editable for the subtasks that are created using a rich text field"
    ],
    "Bug Fixes": [
      "Creation of tasks inside nco or project items will be removed and creating tasks will be done from one location inside the app globally",
      "DataGridPro refactored to DataGridPremium",
      "added restore functions for cancelling agreement editing, this will clear changes and restore initial state for product rows and deal data",
      "cloned deals are now correctly displaying cloned products in their agreements after creation",
      "cloned deals now have Not Invoiced as the default status, their recipients data is also reset and product start and end dates are used for the products that are cloned. Accounting grid comments now include context from the accounting grid itself, and the related comments based on the deal.",
      "cloning will reset deal to the correct state",
      "deal updates in deal details now working correctly, accounting schedule fixed",
      "fixed accounting drawer rendering and data access",
      "fixed and refactored agreements component for saving and updating deals more efficiently, moving on to products table",
      "fixed approvers not being notified when request is made",
      "fixed assignees not updating correctly in team tasks",
      "fixed billed price rendering issue and refactored for more consistent frontend updates",
      "fixed bug with creating a deal and new GSI contractId values",
      "fixed comment counts not rendering in team tasks grid",
      "fixed contracted by and affiliated lists when creating new organizations",
      "fixed contracted by column rendering in mtb",
      "fixed contractedby not updating correctly, cache is syncing to about 75% need to update",
      "fixed dashboard data and boards data",
      "fixed deal deletion and stale data on creation",
      "fixed density not saving correctly when changed in global data grid",
      "fixed drawer state inconsistency in projects",
      "fixed error in data grid when deleting deals, row would try to deselect deleted row, this has been resolved",
      "fixed error when selecting website for organization task in batch creation",
      "fixed errors with expression attribute names import to monday and dealstatus select error, added loading to deal details",
      "fixed filters not saving to local storage, filters should persist after making changes now",
      "fixed formatDayjsDateTime undefined error",
      "fixed implementation fee and product description not saving correctly.",
      "fixed implementation fee bugs, editing and saving efficiently detects changes and when changes are saved, input no longer leaves a trailing 0 when trying to input a new value",
      "fixed incorrect IO totals showing in Invoicing tab for contracts",
      "fixed issues with no signature checkboxes in agreement and create new deal, will efficiently change statuses and stage when deal is checked or unchecked for completed internally and now responds when creating a new deal with the no signature checkbox checked",
      "fixed loading for spend cells in mtb",
      "fixed missing implementation fee from contracts",
      "fixed no scrolling for larger contracts in product rows table",
      "fixed no signature not updating status and stage correctly",
      "fixed nosignature for clone and replace",
      "fixed notes for strategy not loading correctly, fixed products not rendering after a deal is cloned and replaced or just cloned",
      "fixed onSettled bug with updateTaskItems query mutation",
      "fixed organization fields not updating optimistically inside organization details",
      "fixed organization grid missing column data",
      "fixed organization verticals rendering inside organization details",
      "fixed organizations grid filters, added helper to create deal",
      "fixed pdf attachments not rendering properly when accessing through a comments attachment thumbnail",
      "fixed rendering for website projects in projects grid",
      "fixed routing inside child rows for contacts and deals",
      "fixed scrolling behavior for comments when deleting, will now scroll into view for both deletion and editing",
      "fixed selection bug in team tasks for update footer rendering",
      "fixed state inconsistencies after saving contract",
      "fixed syncing in accounting grid and updated strategy endpoints to use the correct table",
      "fixed typeerror in process row update",
      "fixed typeerrors for metric typescript files",
      "fixed white screen when searching for invalid values in entity search",
      "fixes for single and mass updates for team in the MTB",
      "onboarding status can now be updated in bulk or 1 at a time in the nco",
      "optimized loading and selection in deals",
      "organization bug with render objects component fixed",
      "removed panda document matching for now, may reintroduce if needed at a later date",
      "removed type from mass updates for organizations, fixed data types for other updates still included",
      "searching by contracted by will no longer zero out totals in mtb",
      "server fix, updated the generate links endpoint to tag the contracts so they will be sent to recipients upon completion",
      "totals for reviewdeal and details added",
      "type errors fixed and removed jsconfig",
      "updated invoicing components to use deal data hook instead of provider, fixed IOTotalSchedule",
      "updates to useAllItemsLive hook to correct errors when websocket connections syncing",
      "when the price input is cleared completely it will now default to 0.00 instead of an empty string"
    ],
    "Style": [
      "added separation for organization rows in batch create tasks, menu can be pinned and will render upon hovering over the icon on the far right",
      "ancestor -> predecessor | descendant -> succ successor",
      "attachments now a fixed footer for each comment card component",
      "cleaned up styling for batch task creation",
      "colors for clone and replace added more consistently",
      "efficient styling set to assignees in task drawer - subtasks",
      "fixed container issues for accounting schedule",
      "fixed densityModel to correct row height for global data grid",
      "fixed grid sizes for organization selection mtb",
      "fixed placement of loading in nav bar to be consistent with new search component",
      "fixed scrollbar width and color for listitem and list mui",
      "fixed styling for google signature",
      "fixed styling issues for successor and predecessor names and sizing for user settings avatar in nav bar",
      "fixed team tasks grid styling through props",
      "icons added to product list as well as inline helpers for batch creation",
      "loading updated",
      "minimized styling for days left and successor and predecessor rows",
      "rearranged description title to include platform and channel, as well as subtype selected",
      "revised global css styling and themes to correct type errors",
      "revised styling and added more customization to custom loading overlay",
      "style fixes, added sort function for users active products",
      "styling for when phase is off and while phase is work, new styling for loader",
      "styling revisions to agreement edit and view modes",
      "updated styling for rendering details and edit inputs for tasks"
    ],
    "Refactors": [
      "server side refactor, added cached data for the organizations_table to help optimize data fetching. Updated mass updating tasks to invalidate correctly, updated user fetching for assignees, assigner and team",
      "server side refactor, added cached data for the organizations_table to help optimize data fetching. Updated mass updating tasks to invalidate correctly, updated user fetching for assignees, assigner and team",
      "attachments in task details now can be scrolled through, download all now an option, mtb updated and refactored for new structure",
      "changes to nco row updates for organization and deal statuses:bypass",
      "cleaned up console.logs on server side",
      "columns refactored for MTB for efficiency and data fetching optimizations",
      "complete refactor of renderDealsColumns using typescript and custom components, updated useQuery hooks and functions to optimize crud operations",
      "contracts flow completed with new structure, products tab addded to organizations",
      "create deal refactored with typescript and new data structure, deals grid about 80% done",
      "data grid for mtb using raw data to populate grid, product rows now added to mtb rows for testing purposes",
      "deleted 500 files being unused",
      "edit state combined for description and task checklists",
      "fixed optimization and task queries to be more efficient, fixed websockt connections to ping more efficiently",
      "fixed routing in contacts, approvals and accounting grids",
      "full refactor of monthly task board for data grid premium, refactor of organizations and deals grids",
      "full refactor of projects and team tasks to use the global data grid premium and components",
      "fully refactored accounting grid, fixed padding and revised style for global data grid main content",
      "fully type checked files for renderDealColumns and 75% of renderMtbColumns",
      "NCO complete refactor, now using global data grid and tree data to display services that are currently being onboarded",
      "NCO grid refactored for data grid premium, deal mass updates and process row updates all updated for new data grid structure",
      "new endpoints for organizations_table, grids working with new table schema",
      "notifications updates optimized",
      "optimizations made to updates in subtask list, help provider updated to render only in active components when triggered",
      "optimizations tab now has three options for creating opts, insights and observations, rich text field added to the create dialog and the rendered optimizations, insights or observations. Edit mode introduced.",
      "optimized deal state in agreement tab and changes being propogated",
      "optimized filtering for my items in deals grid",
      "optimized queries in task grid and mtb",
      "organizations - details, creation, grid",
      "python script updated for net totals of products, products net totals calculated wwhen deal is edited, totals displayed in deals grid, products now included",
      "refactor for all comments to use queryData instead of invalidating when deleting, creating and updating",
      "refactor in nco drawer, new component, progress tracks for both the task list and integrations checklists, save button renders when integrations checkboxes are edited, efficiency in server side invalidation updated",
      "refactor notifications menu for more efficient rendering, adding and removing confusing data properties to ensure consistent url routes and rendered information",
      "refactor of contacts grid and added tree data for related deals",
      "refactor server side",
      "refactor to nco drawer and grid, updated the mass update and single update render and functionality, updated table in drawer for efficiency",
      "refactored and added logic to bootstrap endpoint and utility, cache will automatically refresh once every 5 minutes during work hours, once a minute during busy hours and once an hour during off hours",
      "refactored batch creation to not include auto descriptions, only titles",
      "refactored context for data grid data and components, introduced loading overlay for organizations_table loading and no rows overlay for when no data result",
      "refactored Dashboard page to include active products and updated fetching for organizations and deals",
      "refactored deal product rows in deals grid to only render when expanding parent row, need to assess aggregation",
      "refactored delete endpoint to remove successorId when needed from predecessor and efficiently delete products when a deal is deleted",
      "refactored description functionality to new file and revised logic",
      "refactored editor.tsx to TextEditor.tsx TextEditorFooter.tsx TexEditorControls.tsx for more efficient and type safe components",
      "refactored export to only include filtered values in organization grid",
      "refactored formatted data being used for organizations inside the monthly task board, added density options to MTB",
      "refactored grid toolbar to contain the invoiced and not invoiced filters for accounting",
      "refactored nco drawer to efficiently sync cache after statuses are updated inline or with the new launch onboard button. Launch onboard button will render when onboarding is completed.",
      "refactored nco grid drawer to display assignees before task list is created, conditionally render the SEO form, seo tab and progress pct for meta page and seo dependencies",
      "refactored NCO task list to allow for selection of tasks upon creation, they can also select which tasks to create with the list and delete specific rows after the list is created",
      "refactored NCO with new fields to track SEO, updated the logic to correctly create task lists based on products contracted",
      "refactored notifications server and client side for more efficient fetching and invalidation",
      "refactored onboarding task list to zero dependencies, removed extra statuses in onboarding status filters",
      "refactored projects grid to function similarly to the team tasks grid",
      "refactored python script for importing data into single table design. added oldStatus property to deals for comparison after import",
      "refactored query cache syncing to efficiently work for updates to checklists, details and description inside task details drawer. Progress tracked from checklist and updates the grid correctly",
      "refactored review deal and useDealData product rows sorting for more accuracy",
      "refactored save and update for completed internally to update cloned and replaced deals with correct statuses, as well as updates to their products. Added dealStatus to deals in EntitySearch component, google tag manager scopes added to google authorization",
      "refactored server side code for reassigning recipients",
      "refactored server side data fetching for organizations_table, python script for syncing dates, updating status and deal status added. monthly metrics for totals and media spend added to MTB.",
      "refactored server side logic for organizations_table data, totals coming in for digital, creative and IO type contracts monthly. Optimized rendering for deals header",
      "refactored server side organizations_table.js and python scripts",
      "refactored task list for nco, onboarding team editable in grid and drawer",
      "refactored team tasks to use tasks table data for all crud operations, updated to use datagrid premium",
      "refactored TextEditor to use more efficient styling when attachments are input, deleting pasted images will now remove them from the attachments as well. Website build checklist updated correctly and website hosting tasks updated with a simplified version",
      "refactored updates for checklists and organization profile to update query cache instead of invalidation",
      "refactored updates for team tasks board to efficiently update cache on creation of tasks",
      "refactored updates for when deal is won to also update onboarding status to staging when the deal is an msa or msa - housing, this will place the deal in the NCO for onboarding",
      "refactored useAllItems hook to also include websocket connection so deleted data will not be updated in real time",
      "refactored version of form_config created for creative/project tasks, styling revised for display in team tasks grid",
      "refactored webhook server side and tested full contract flow, deal is updated at each stage and imported to monday, notifications sent and if deal was cloned the predecessor is successfully updated to replaced and products updated",
      "refactors to rendermtbcolumns.tsx",
      "request approval now working with new structure and save / update refactored",
      "row selection models changed for organizations, deals, mtb for data grid, updates started for team tasks",
      "server optimizations for queries",
      "server side refactor - webhook updated to correctly change statuses to replaced when a deal is cloned and replaced, as well as update the predecessors products based on start and end date. Before this the successor deal is updated with the correct statuses and imported into Monday",
      "server side refactor for panda doc webhook, new GSI created for contractId that can be queried to grab the related deal and supply the webhook with data needed. This query uses minimal server memory and consumed capacity",
      "server side refactor, added cached data for the organizations_table to help optimize data fetching. Updated mass updating tasks to invalidate correctly, updated user fetching for assignees, assigner and team",
      "server side refactoring for efficient websocket updates when contracts are created, reverted, links generated and completed",
      "strategy updated and updates for products changed to individual line items in rendered strategy",
      "synced loading for items",
      "task table deletion update for more efficiency and added one time clear for local storage when large updates are pushed",
      "tasks table now added to global fetching on app load",
      "text editor input efficiently expanding and collapsing based on focus or when a comment is posted",
      "updates for mtb and team tasks refactored",
      "updating contracts, approval flow, creating contracts and requesting approval updated for new structure",
      "validation added to batch tasks for org rows and for creation",
      "webhook working for everything except updating the predecessor to replaced"
    ]
  },
  "12.10.0": {
    "date": "2025-10-02",
    "Features": [
      "NEW FEATURE: when using the Clone deal feature, users can change the organization and it will still duplicate the deal that was selected for cloning but replace the deals organization details with the new organization selected. This only works for cloning only, not for clone and replace"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "12.9.9": {
    "date": "2025-10-02",
    "Features": [],
    "Bug Fixes": [
      "fixed no scrolling for larger contracts in product rows table"
    ],
    "Style": [],
    "Refactors": []
  },
  "12.9.8": {
    "date": "2025-10-02",
    "Features": [],
    "Bug Fixes": [
      "fixed pdf attachments not rendering properly when accessing through a comments attachment thumbnail"
    ],
    "Style": [],
    "Refactors": []
  },
  "12.9.7": {
    "date": "2025-10-02",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "attachments now a fixed footer for each comment card component"
    ],
    "Refactors": []
  },
  "12.9.6": {
    "date": "2025-10-01",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "fixed scrollbar width and color for listitem and list mui"
    ],
    "Refactors": []
  },
  "12.9.5": {
    "date": "2025-10-01",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactored TextEditor to use more efficient styling when attachments are input, deleting pasted images will now remove them from the attachments as well. Website build checklist updated correctly and website hosting tasks updated with a simplified version"
    ]
  },
  "12.9.4": {
    "date": "2025-10-01",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "style fixes, added sort function for users active products"
    ],
    "Refactors": []
  },
  "12.9.3": {
    "date": "2025-09-30",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactor notifications menu for more efficient rendering, adding and removing confusing data properties to ensure consistent url routes and rendered information"
    ]
  },
  "12.9.2": {
    "date": "2025-09-30",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "updated styling for rendering details and edit inputs for tasks"
    ],
    "Refactors": []
  },
  "12.9.1": {
    "date": "2025-09-30",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactored query cache syncing to efficiently work for updates to checklists, details and description inside task details drawer. Progress tracked from checklist and updates the grid correctly"
    ]
  },
  "12.9.0": {
    "date": "2025-09-30",
    "Features": [
      "Editing now available in task drawer, task layout changed. uploaded attachments and images more efficiently rendered in task drawer footer"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "12.8.0": {
    "date": "2025-09-29",
    "Features": [
      "pasting into rich text editor will now upload images after posting and also attach them to the comment. Styling greatly revised for efficiency"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "12.7.4": {
    "date": "2025-09-29",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "text editor input efficiently expanding and collapsing based on focus or when a comment is posted"
    ]
  },
  "12.7.3": {
    "date": "2025-09-29",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactored editor.tsx to TextEditor.tsx TextEditorFooter.tsx TexEditorControls.tsx for more efficient and type safe components"
    ]
  },
  "12.7.2": {
    "date": "2025-09-26",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactored nco drawer to efficiently sync cache after statuses are updated inline or with the new launch onboard button. Launch onboard button will render when onboarding is completed."
    ]
  },
  "12.7.1": {
    "date": "2025-09-26",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactored export to only include filtered values in organization grid"
    ]
  },
  "12.7.0": {
    "date": "2025-09-26",
    "Features": [
      "tree data reintroduced to organizations grid, export will format headers, org names and some cell values and include the related products nested with their organizations if they are active currently"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "12.6.4": {
    "date": "2025-09-26",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactored review deal and useDealData product rows sorting for more accuracy"
    ]
  },
  "12.6.3": {
    "date": "2025-09-26",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "changes to nco row updates for organization and deal statuses:bypass"
    ]
  },
  "12.6.2": {
    "date": "2025-09-25",
    "Features": [],
    "Bug Fixes": [
      "fixed rendering for website projects in projects grid"
    ],
    "Style": [],
    "Refactors": []
  },
  "12.6.1": {
    "date": "2025-09-25",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "edit state combined for description and task checklists"
    ]
  },
  "12.6.0": {
    "date": "2025-09-25",
    "Features": [
      "checklist now auto creating based on creative task chosen, editable fields to be rendered next"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "12.5.7": {
    "date": "2025-09-25",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactored projects grid to function similarly to the team tasks grid"
    ]
  },
  "12.5.6": {
    "date": "2025-09-25",
    "Features": [],
    "Bug Fixes": [
      "fixed density not saving correctly when changed in global data grid"
    ],
    "Style": [],
    "Refactors": []
  },
  "12.5.5": {
    "date": "2025-09-24",
    "Features": [],
    "Bug Fixes": [
      "fixed white screen when searching for invalid values in entity search"
    ],
    "Style": [],
    "Refactors": []
  },
  "12.5.4": {
    "date": "2025-09-24",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactored nco grid drawer to display assignees before task list is created, conditionally render the SEO form, seo tab and progress pct for meta page and seo dependencies"
    ]
  },
  "12.5.3": {
    "date": "2025-09-24",
    "Features": [],
    "Bug Fixes": [
      "fixed comment counts not rendering in team tasks grid"
    ],
    "Style": [],
    "Refactors": []
  },
  "12.5.2": {
    "date": "2025-09-24",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactored batch creation to not include auto descriptions, only titles"
    ]
  },
  "12.5.1": {
    "date": "2025-09-23",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactored version of form_config created for creative/project tasks, styling revised for display in team tasks grid"
    ]
  },
  "12.5.0": {
    "date": "2025-09-22",
    "Features": [
      "new drawer feature added for extra fields need in batch creation, Integration Services - Hourly product added to database"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "12.4.1": {
    "date": "2025-09-22",
    "Features": [],
    "Bug Fixes": [
      "fixed organization verticals rendering inside organization details"
    ],
    "Style": [],
    "Refactors": []
  },
  "12.4.0": {
    "date": "2025-09-22",
    "Features": [
      "row selection added to batch creation of tasks, when a row is selected the drawer will render with extra fields to be edited, the radio button can be used while the drawer is open to navigate between rows and edit different tasks without closing the drawer"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "12.3.0": {
    "date": "2025-09-19",
    "Features": [
      "testing batch task creation on a separate route and page"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "12.2.10": {
    "date": "2025-09-19",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactored NCO with new fields to track SEO, updated the logic to correctly create task lists based on products contracted"
    ]
  },
  "12.2.9": {
    "date": "2025-09-18",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "rearranged description title to include platform and channel, as well as subtype selected"
    ],
    "Refactors": []
  },
  "12.2.8": {
    "date": "2025-09-18",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactored description functionality to new file and revised logic"
    ]
  },
  "12.2.7": {
    "date": "2025-09-18",
    "Features": [],
    "Bug Fixes": [
      "fixed error when selecting website for organization task in batch creation"
    ],
    "Style": [],
    "Refactors": []
  },
  "12.2.6": {
    "date": "2025-09-18",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "icons added to product list as well as inline helpers for batch creation"
    ],
    "Refactors": []
  },
  "12.2.5": {
    "date": "2025-09-18",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "validation added to batch tasks for org rows and for creation"
    ]
  },
  "12.2.4": {
    "date": "2025-09-18",
    "Features": [],
    "Bug Fixes": [
      "fixed organization fields not updating optimistically inside organization details"
    ],
    "Style": [],
    "Refactors": []
  },
  "12.2.3": {
    "date": "2025-09-18",
    "Features": [],
    "Bug Fixes": [
      "when the price input is cleared completely it will now default to 0.00 instead of an empty string"
    ],
    "Style": [],
    "Refactors": []
  },
  "12.2.2": {
    "date": "2025-09-17",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "added separation for organization rows in batch create tasks, menu can be pinned and will render upon hovering over the icon on the far right"
    ],
    "Refactors": []
  },
  "12.2.1": {
    "date": "2025-09-17",
    "Features": [],
    "Bug Fixes": [
      "fixed contractedby not updating correctly, cache is syncing to about 75% need to update"
    ],
    "Style": [],
    "Refactors": []
  },
  "12.2.0": {
    "date": "2025-09-16",
    "Features": [
      "new feature for creating organization level tasks in creating batch tasks"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "12.1.6": {
    "date": "2025-09-16",
    "Features": [],
    "Bug Fixes": [
      "fixed implementation fee and product description not saving correctly."
    ],
    "Style": [],
    "Refactors": []
  },
  "12.1.5": {
    "date": "2025-09-16",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactored updates for team tasks board to efficiently update cache on creation of tasks"
    ]
  },
  "12.1.4": {
    "date": "2025-09-15",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "cleaned up styling for batch task creation"
    ],
    "Refactors": []
  },
  "12.1.3": {
    "date": "2025-09-11",
    "Features": [],
    "Bug Fixes": [
      "optimized loading and selection in deals"
    ],
    "Style": [],
    "Refactors": []
  },
  "12.1.2": {
    "date": "2025-09-11",
    "Features": [],
    "Bug Fixes": [
      "removed panda document matching for now, may reintroduce if needed at a later date"
    ],
    "Style": [],
    "Refactors": []
  },
  "12.1.1": {
    "date": "2025-09-11",
    "Features": [],
    "Bug Fixes": [
      "fixed nosignature for clone and replace"
    ],
    "Style": [],
    "Refactors": []
  },
  "12.1.0": {
    "date": "2025-09-11",
    "Features": [
      "refactored and added new selections for batch task creation"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "12.0.6": {
    "date": "2025-09-10",
    "Features": [],
    "Bug Fixes": [
      "server fix, updated the generate links endpoint to tag the contracts so they will be sent to recipients upon completion"
    ],
    "Style": [],
    "Refactors": []
  },
  "12.0.5": {
    "date": "2025-09-10",
    "Features": [],
    "Bug Fixes": [
      "fixed filters not saving to local storage, filters should persist after making changes now"
    ],
    "Style": [],
    "Refactors": []
  },
  "12.0.4": {
    "date": "2025-09-09",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactored onboarding task list to zero dependencies, removed extra statuses in onboarding status filters"
    ]
  },
  "12.0.3": {
    "date": "2025-09-09",
    "Features": [],
    "Bug Fixes": [
      "fixed approvers not being notified when request is made"
    ],
    "Style": [],
    "Refactors": []
  },
  "12.0.2": {
    "date": "2025-09-09",
    "Features": [],
    "Bug Fixes": [
      "fixed no signature not updating status and stage correctly"
    ],
    "Style": [],
    "Refactors": []
  },
  "12.0.1": {
    "date": "2025-09-09",
    "Features": [],
    "Bug Fixes": [
      "fixed contracted by and affiliated lists when creating new organizations"
    ],
    "Style": [],
    "Refactors": []
  },
  "12.0.0": {
    "date": "2025-09-08",
    "Features": [
      "New batch create for tasks to simplify task management"
    ],
    "Bug Fixes": [
      "Creation of tasks inside nco or project items will be removed and creating tasks will be done from one location inside the app globally"
    ],
    "Style": [],
    "Refactors": []
  },
  "11.13.8": {
    "date": "2025-09-08",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "fixed densityModel to correct row height for global data grid"
    ],
    "Refactors": []
  },
  "11.13.7": {
    "date": "2025-09-08",
    "Features": [],
    "Bug Fixes": [
      "totals for reviewdeal and details added"
    ],
    "Style": [],
    "Refactors": []
  },
  "11.13.6": {
    "date": "2025-09-07",
    "Features": [],
    "Bug Fixes": [
      "fixed issues with no signature checkboxes in agreement and create new deal, will efficiently change statuses and stage when deal is checked or unchecked for completed internally and now responds when creating a new deal with the no signature checkbox checked"
    ],
    "Style": [],
    "Refactors": []
  },
  "11.13.5": {
    "date": "2025-09-07",
    "Features": [],
    "Bug Fixes": [
      "fixed incorrect IO totals showing in Invoicing tab for contracts"
    ],
    "Style": [],
    "Refactors": []
  },
  "11.13.4": {
    "date": "2025-09-07",
    "Features": [],
    "Bug Fixes": [
      "fixed implementation fee bugs, editing and saving efficiently detects changes and when changes are saved, input no longer leaves a trailing 0 when trying to input a new value"
    ],
    "Style": [],
    "Refactors": []
  },
  "11.13.3": {
    "date": "2025-09-04",
    "Features": [],
    "Bug Fixes": [
      "fixed missing implementation fee from contracts"
    ],
    "Style": [],
    "Refactors": []
  },
  "11.13.2": {
    "date": "2025-08-30",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "styling for when phase is off and while phase is work, new styling for loader"
    ],
    "Refactors": []
  },
  "11.13.1": {
    "date": "2025-08-29",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactored updates for when deal is won to also update onboarding status to staging when the deal is an msa or msa - housing, this will place the deal in the NCO for onboarding"
    ]
  },
  "11.13.0": {
    "date": "2025-08-29",
    "Features": [
      "pinned rows now rendering in NCO based on staging deal stage, creating task list and starting onboarding changes stage to onboarding and removes from pinned list, styling fixes and server fix to update date won when contract is fully completed"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "11.12.2": {
    "date": "2025-08-29",
    "Features": [],
    "Bug Fixes": [
      "updated invoicing components to use deal data hook instead of provider, fixed IOTotalSchedule"
    ],
    "Style": [],
    "Refactors": []
  },
  "11.12.1": {
    "date": "2025-08-29",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "cleaned up console.logs on server side"
    ]
  },
  "11.12.0": {
    "date": "2025-08-29",
    "Features": [
      "SEO checklist now creating based on tier and the jotform link is included, progress will track for the checklist as well"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "11.11.0": {
    "date": "2025-08-29",
    "Features": [
      "added bootstrap health button for metrics on last cache invalidation and to test timing during work hours"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "11.10.7": {
    "date": "2025-08-28",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactored and added logic to bootstrap endpoint and utility, cache will automatically refresh once every 5 minutes during work hours, once a minute during busy hours and once an hour during off hours"
    ]
  },
  "11.10.6": {
    "date": "2025-08-28",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "fixed styling issues for successor and predecessor names and sizing for user settings avatar in nav bar"
    ],
    "Refactors": []
  },
  "11.10.5": {
    "date": "2025-08-28",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactored grid toolbar to contain the invoiced and not invoiced filters for accounting"
    ]
  },
  "11.10.4": {
    "date": "2025-08-28",
    "Features": [],
    "Bug Fixes": [
      "fixed error in data grid when deleting deals, row would try to deselect deleted row, this has been resolved"
    ],
    "Style": [],
    "Refactors": []
  },
  "11.10.3": {
    "date": "2025-08-28",
    "Features": [],
    "Bug Fixes": [
      "fixed bug with creating a deal and new GSI contractId values"
    ],
    "Style": [],
    "Refactors": []
  },
  "11.10.2": {
    "date": "2025-08-28",
    "Features": [],
    "Bug Fixes": [
      "updates to useAllItemsLive hook to correct errors when websocket connections syncing"
    ],
    "Style": [],
    "Refactors": []
  },
  "11.10.1": {
    "date": "2025-08-28",
    "Features": [],
    "Bug Fixes": [
      "fixed notes for strategy not loading correctly, fixed products not rendering after a deal is cloned and replaced or just cloned"
    ],
    "Style": [],
    "Refactors": []
  },
  "11.10.0": {
    "date": "2025-08-28",
    "Features": [
      "batch delete added to leads table"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "11.9.5": {
    "date": "2025-08-28",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "revised styling and added more customization to custom loading overlay"
    ],
    "Refactors": []
  },
  "11.9.4": {
    "date": "2025-08-28",
    "Features": [],
    "Bug Fixes": [
      "fixed syncing in accounting grid and updated strategy endpoints to use the correct table"
    ],
    "Style": [],
    "Refactors": []
  },
  "11.9.3": {
    "date": "2025-08-28",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactored webhook server side and tested full contract flow, deal is updated at each stage and imported to monday, notifications sent and if deal was cloned the predecessor is successfully updated to replaced and products updated"
    ]
  },
  "11.9.2": {
    "date": "2025-08-28",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactor in nco drawer, new component, progress tracks for both the task list and integrations checklists, save button renders when integrations checkboxes are edited, efficiency in server side invalidation updated"
    ]
  },
  "11.9.1": {
    "date": "2025-08-26",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "task table deletion update for more efficiency and added one time clear for local storage when large updates are pushed"
    ]
  },
  "11.9.0": {
    "date": "2025-08-26",
    "Features": [
      "new endpoint server side for bootstrap loading and bootstrap health, cache will be used by all connected users and cache health can be viewed by hovering over the grobotic logo, greatly increases efficiency, reduces cost and greatly reduces stress on server"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "11.8.11": {
    "date": "2025-08-26",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "server side refactor for panda doc webhook, new GSI created for contractId that can be queried to grab the related deal and supply the webhook with data needed. This query uses minimal server memory and consumed capacity"
    ]
  },
  "11.8.10": {
    "date": "2025-08-26",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactored updates for checklists and organization profile to update query cache instead of invalidation"
    ]
  },
  "11.8.9": {
    "date": "2025-08-26",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactored task list for nco, onboarding team editable in grid and drawer"
    ]
  },
  "11.8.8": {
    "date": "2025-08-25",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactor to nco drawer and grid, updated the mass update and single update render and functionality, updated table in drawer for efficiency"
    ]
  },
  "11.8.7": {
    "date": "2025-08-25",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactored NCO task list to allow for selection of tasks upon creation, they can also select which tasks to create with the list and delete specific rows after the list is created"
    ]
  },
  "11.8.6": {
    "date": "2025-08-21",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "NCO complete refactor, now using global data grid and tree data to display services that are currently being onboarded"
    ]
  },
  "11.8.5": {
    "date": "2025-08-20",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactored delete endpoint to remove successorId when needed from predecessor and efficiently delete products when a deal is deleted"
    ]
  },
  "11.8.4": {
    "date": "2025-08-20",
    "Features": [],
    "Bug Fixes": [
      "fixed errors with expression attribute names import to monday and dealstatus select error, added loading to deal details"
    ],
    "Style": [],
    "Refactors": []
  },
  "11.8.3": {
    "date": "2025-08-20",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "synced loading for items"
    ]
  },
  "11.8.2": {
    "date": "2025-08-20",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "minimized styling for days left and successor and predecessor rows"
    ],
    "Refactors": []
  },
  "11.8.1": {
    "date": "2025-08-19",
    "Features": [],
    "Bug Fixes": [
      "fixed state inconsistencies after saving contract"
    ],
    "Style": [],
    "Refactors": []
  },
  "11.8.0": {
    "date": "2025-08-19",
    "Features": [
      "added new notification to webhook, newbusiness channel will receive a deal won notification with the deal name and total value"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "11.7.12": {
    "date": "2025-08-19",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactored context for data grid data and components, introduced loading overlay for organizations_table loading and no rows overlay for when no data result"
    ]
  },
  "11.7.11": {
    "date": "2025-08-18",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "fixed optimization and task queries to be more efficient, fixed websockt connections to ping more efficiently"
    ]
  },
  "11.7.10": {
    "date": "2025-08-18",
    "Features": [],
    "Bug Fixes": [
      "fixed scrolling behavior for comments when deleting, will now scroll into view for both deletion and editing"
    ],
    "Style": [],
    "Refactors": []
  },
  "11.7.9": {
    "date": "2025-08-16",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactored deal product rows in deals grid to only render when expanding parent row, need to assess aggregation"
    ]
  },
  "11.7.8": {
    "date": "2025-08-16",
    "Features": [],
    "Bug Fixes": [
      "added restore functions for cancelling agreement editing, this will clear changes and restore initial state for product rows and deal data"
    ],
    "Style": [],
    "Refactors": []
  },
  "11.7.7": {
    "date": "2025-08-15",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactor for all comments to use queryData instead of invalidating when deleting, creating and updating"
    ]
  },
  "11.7.6": {
    "date": "2025-08-15",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactored notifications server and client side for more efficient fetching and invalidation"
    ]
  },
  "11.7.5": {
    "date": "2025-08-14",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "server side refactoring for efficient websocket updates when contracts are created, reverted, links generated and completed"
    ]
  },
  "11.7.4": {
    "date": "2025-08-13",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactored useAllItems hook to also include websocket connection so deleted data will not be updated in real time"
    ]
  },
  "11.7.3": {
    "date": "2025-08-13",
    "Features": [],
    "Bug Fixes": [
      "fixed deal deletion and stale data on creation"
    ],
    "Style": [],
    "Refactors": []
  },
  "11.7.2": {
    "date": "2025-08-13",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactored server side code for reassigning recipients"
    ]
  },
  "11.7.1": {
    "date": "2025-08-13",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "styling revisions to agreement edit and view modes"
    ],
    "Refactors": []
  },
  "11.7.0": {
    "date": "2025-08-12",
    "Features": [
      "major refactor of agreements tab, reassigning and updating recipients now functioning correctly, need to update cache upon update successful. UI change detection introduced"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "11.6.0": {
    "date": "2025-08-11",
    "Features": [
      "major refactor of contracts functionality, new edit and save view modes, server side refactoring of requests to increase efficiency. Flow is complete up to requesting approval and creating contract, need to refactor for save and update when contract has been created"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "11.5.6": {
    "date": "2025-08-11",
    "Features": [],
    "Bug Fixes": [
      "fixed and refactored agreements component for saving and updating deals more efficiently, moving on to products table"
    ],
    "Style": [],
    "Refactors": []
  },
  "11.5.5": {
    "date": "2025-08-08",
    "Features": [],
    "Bug Fixes": [
      "fixed typeerror in process row update"
    ],
    "Style": [],
    "Refactors": []
  },
  "11.5.4": {
    "date": "2025-08-05",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactor server side"
    ]
  },
  "11.5.3": {
    "date": "2025-08-04",
    "Features": [],
    "Bug Fixes": [
      "searching by contracted by will no longer zero out totals in mtb"
    ],
    "Style": [],
    "Refactors": []
  },
  "11.5.2": {
    "date": "2025-08-04",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "fixed styling for google signature"
    ],
    "Refactors": []
  },
  "11.5.1": {
    "date": "2025-08-04",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "python script updated for net totals of products, products net totals calculated wwhen deal is edited, totals displayed in deals grid, products now included"
    ]
  },
  "11.5.0": {
    "date": "2025-08-03",
    "Features": [
      "added cache timer to tooltip over the grobotic logo in top left, timer represents table data expiry timer for reference"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "11.4.0": {
    "date": "2025-08-01",
    "Features": [
      "updated dashboard page to include products, organizations, deals and tasks"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "11.3.11": {
    "date": "2025-08-01",
    "Features": [],
    "Bug Fixes": [
      "fixed routing inside child rows for contacts and deals"
    ],
    "Style": [],
    "Refactors": []
  },
  "11.3.10": {
    "date": "2025-08-01",
    "Features": [],
    "Bug Fixes": [
      "fixed assignees not updating correctly in team tasks"
    ],
    "Style": [],
    "Refactors": []
  },
  "11.3.9": {
    "date": "2025-08-01",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactor of contacts grid and added tree data for related deals"
    ]
  },
  "11.3.8": {
    "date": "2025-08-01",
    "Features": [],
    "Bug Fixes": [
      "fixed organization grid missing column data"
    ],
    "Style": [],
    "Refactors": []
  },
  "11.3.7": {
    "date": "2025-07-31",
    "Features": [],
    "Bug Fixes": [
      "fixed drawer state inconsistency in projects"
    ],
    "Style": [],
    "Refactors": []
  },
  "11.3.6": {
    "date": "2025-07-31",
    "Features": [],
    "Bug Fixes": [
      "fixed selection bug in team tasks for update footer rendering"
    ],
    "Style": [],
    "Refactors": []
  },
  "11.3.5": {
    "date": "2025-07-31",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "fixed team tasks grid styling through props"
    ],
    "Refactors": []
  },
  "11.3.4": {
    "date": "2025-07-31",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "full refactor of projects and team tasks to use the global data grid premium and components"
    ]
  },
  "11.3.3": {
    "date": "2025-07-30",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactored team tasks to use tasks table data for all crud operations, updated to use datagrid premium"
    ]
  },
  "11.3.2": {
    "date": "2025-07-30",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "fully refactored accounting grid, fixed padding and revised style for global data grid main content"
    ]
  },
  "11.3.1": {
    "date": "2025-07-30",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactored formatted data being used for organizations inside the monthly task board, added density options to MTB"
    ]
  },
  "11.3.0": {
    "date": "2025-07-30",
    "Features": [
      "density selector added, refactored toolbar for dynamic use in different grid components"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "11.2.2": {
    "date": "2025-07-28",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "tasks table now added to global fetching on app load"
    ]
  },
  "11.2.1": {
    "date": "2025-07-28",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "NCO grid refactored for data grid premium, deal mass updates and process row updates all updated for new data grid structure"
    ]
  },
  "11.2.0": {
    "date": "2025-07-28",
    "Features": [
      "product rows now available in organizations table"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "11.1.3": {
    "date": "2025-07-27",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "data grid for mtb using raw data to populate grid, product rows now added to mtb rows for testing purposes"
    ]
  },
  "11.1.2": {
    "date": "2025-07-25",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "row selection models changed for organizations, deals, mtb for data grid, updates started for team tasks"
    ]
  },
  "11.1.1": {
    "date": "2025-07-24",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "full refactor of monthly task board for data grid premium, refactor of organizations and deals grids"
    ]
  },
  "11.1.0": {
    "date": "2025-07-23",
    "Features": [
      "new user settings options added to header for app, updating gmail signature now available inside user settings."
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "11.0.0": {
    "date": "2025-07-22",
    "Features": [
      "DataGridPro refactored to DataGridPremium",
      "New DataGrids added to all boards, aggregation will be included for columns, more customizations will be added"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "10.50.0": {
    "date": "2025-07-21",
    "Features": [
      "dynamic filtering in monthly task board, selecting a month will display aggregate totals and when you type in a search for a specific value, the totals will change based on the rows returned"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "10.49.1": {
    "date": "2025-07-21",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactored Dashboard page to include active products and updated fetching for organizations and deals"
    ]
  },
  "10.49.0": {
    "date": "2025-07-21",
    "Features": [
      "monthly filter will now show different totals for every month of the year, including past and future months. This will show totals for monthly contract amount and monthly media spend, this also removes rows not containing those months"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "10.48.3": {
    "date": "2025-07-18",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "server side refactor, added cached data for the organizations_table to help optimize data fetching. Updated mass updating tasks to invalidate correctly, updated user fetching for assignees, assigner and team",
      "server side refactor, added cached data for the organizations_table to help optimize data fetching. Updated mass updating tasks to invalidate correctly, updated user fetching for assignees, assigner and team",
      "deleted 500 files being unused"
    ]
  },
  "10.48.2": {
    "date": "2025-07-18",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "deleted 500 files being unused"
    ]
  },
  "10.48.1": {
    "date": "2025-07-18",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "server side refactor, added cached data for the organizations_table to help optimize data fetching. Updated mass updating tasks to invalidate correctly, updated user fetching for assignees, assigner and team"
    ]
  },
  "10.48.0": {
    "date": "2025-07-18",
    "Features": [
      "leasing percentage now an option available when creating optimizations in mtb"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "10.47.1": {
    "date": "2025-07-17",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactored save and update for completed internally to update cloned and replaced deals with correct statuses, as well as updates to their products. Added dealStatus to deals in EntitySearch component, google tag manager scopes added to google authorization"
    ]
  },
  "10.47.0": {
    "date": "2025-07-17",
    "Features": [
      "Deals comments now available, optimizations made for accounting grid and mtb rendering"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "10.46.7": {
    "date": "2025-07-16",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactored server side logic for organizations_table data, totals coming in for digital, creative and IO type contracts monthly. Optimized rendering for deals header"
    ]
  },
  "10.46.6": {
    "date": "2025-07-16",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "optimized deal state in agreement tab and changes being propogated"
    ]
  },
  "10.46.5": {
    "date": "2025-07-16",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "optimized filtering for my items in deals grid"
    ]
  },
  "10.46.4": {
    "date": "2025-07-15",
    "Features": [],
    "Bug Fixes": [
      "fixed billed price rendering issue and refactored for more consistent frontend updates"
    ],
    "Style": [],
    "Refactors": []
  },
  "10.46.3": {
    "date": "2025-07-15",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactored server side organizations_table.js and python scripts"
    ]
  },
  "10.46.2": {
    "date": "2025-07-08",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactored server side data fetching for organizations_table, python script for syncing dates, updating status and deal status added. monthly metrics for totals and media spend added to MTB."
    ]
  },
  "10.46.1": {
    "date": "2025-07-07",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactored python script for importing data into single table design. added oldStatus property to deals for comparison after import"
    ]
  },
  "10.46.0": {
    "date": "2025-07-03",
    "Features": [
      "new month filtering inside the monthly task board, progress and tasks will be filtered to the current month by default"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "10.45.4": {
    "date": "2025-07-03",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "strategy updated and updates for products changed to individual line items in rendered strategy"
    ]
  },
  "10.45.3": {
    "date": "2025-07-03",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "updates for mtb and team tasks refactored"
    ]
  },
  "10.45.2": {
    "date": "2025-07-02",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "optimizations made to updates in subtask list, help provider updated to render only in active components when triggered"
    ]
  },
  "10.45.1": {
    "date": "2025-07-02",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "efficient styling set to assignees in task drawer - subtasks"
    ],
    "Refactors": []
  },
  "10.45.0": {
    "date": "2025-07-02",
    "Features": [
      "added feedback when deleting subtasks from tasks, insights now have a date range to choose instead of a follow up date, save icon for assignees simplified"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "10.44.0": {
    "date": "2025-07-02",
    "Features": [
      "inside the task drawer in team tasks, assignees can be saved using the check icon after making changes, this will immediately save and update the task"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "10.43.0": {
    "date": "2025-07-01",
    "Features": [
      "when creating tasks, description is now editable for the subtasks that are created using a rich text field"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "10.42.20": {
    "date": "2025-07-01",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "optimizations tab now has three options for creating opts, insights and observations, rich text field added to the create dialog and the rendered optimizations, insights or observations. Edit mode introduced."
    ]
  },
  "10.42.19": {
    "date": "2025-06-30",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "server side refactor - webhook updated to correctly change statuses to replaced when a deal is cloned and replaced, as well as update the predecessors products based on start and end date. Before this the successor deal is updated with the correct statuses and imported into Monday"
    ]
  },
  "10.42.18": {
    "date": "2025-06-30",
    "Features": [],
    "Bug Fixes": [
      "fixes for single and mass updates for team in the MTB"
    ],
    "Style": [],
    "Refactors": []
  },
  "10.42.17": {
    "date": "2025-06-30",
    "Features": [],
    "Bug Fixes": [
      "fixed contracted by column rendering in mtb"
    ],
    "Style": [],
    "Refactors": []
  },
  "10.42.16": {
    "date": "2025-06-30",
    "Features": [],
    "Bug Fixes": [
      "fixed organizations grid filters, added helper to create deal"
    ],
    "Style": [],
    "Refactors": []
  },
  "10.42.15": {
    "date": "2025-06-29",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "notifications updates optimized"
    ]
  },
  "10.42.14": {
    "date": "2025-06-29",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "fixed routing in contacts, approvals and accounting grids"
    ]
  },
  "10.42.13": {
    "date": "2025-06-28",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "loading updated"
    ],
    "Refactors": []
  },
  "10.42.12": {
    "date": "2025-06-28",
    "Features": [],
    "Bug Fixes": [
      "fixed accounting drawer rendering and data access"
    ],
    "Style": [],
    "Refactors": []
  },
  "10.42.11": {
    "date": "2025-06-27",
    "Features": [],
    "Bug Fixes": [
      "fixed dashboard data and boards data"
    ],
    "Style": [],
    "Refactors": []
  },
  "10.42.10": {
    "date": "2025-06-27",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "fixed container issues for accounting schedule"
    ],
    "Refactors": []
  },
  "10.42.9": {
    "date": "2025-06-27",
    "Features": [],
    "Bug Fixes": [
      "deal updates in deal details now working correctly, accounting schedule fixed"
    ],
    "Style": [],
    "Refactors": []
  },
  "10.42.8": {
    "date": "2025-06-27",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "attachments in task details now can be scrolled through, download all now an option, mtb updated and refactored for new structure"
    ]
  },
  "10.42.7": {
    "date": "2025-06-26",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "server optimizations for queries"
    ]
  },
  "10.42.6": {
    "date": "2025-06-26",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "optimized queries in task grid and mtb"
    ]
  },
  "10.42.5": {
    "date": "2025-06-25",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "webhook working for everything except updating the predecessor to replaced"
    ]
  },
  "10.42.4": {
    "date": "2025-06-25",
    "Features": [],
    "Bug Fixes": [
      "cloned deals are now correctly displaying cloned products in their agreements after creation"
    ],
    "Style": [],
    "Refactors": []
  },
  "10.42.3": {
    "date": "2025-06-24",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "contracts flow completed with new structure, products tab addded to organizations"
    ]
  },
  "10.42.2": {
    "date": "2025-06-24",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "updating contracts, approval flow, creating contracts and requesting approval updated for new structure"
    ]
  },
  "10.42.1": {
    "date": "2025-06-23",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "request approval now working with new structure and save / update refactored"
    ]
  },
  "10.42.0": {
    "date": "2025-06-23",
    "Features": [
      "create new deal added and updated, timelines refactored for deals"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "10.41.4": {
    "date": "2025-06-20",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "create deal refactored with typescript and new data structure, deals grid about 80% done"
    ]
  },
  "10.41.3": {
    "date": "2025-06-19",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "organizations - details, creation, grid"
    ]
  },
  "10.41.2": {
    "date": "2025-06-18",
    "Features": [],
    "Bug Fixes": [
      "type errors fixed and removed jsconfig"
    ],
    "Style": [],
    "Refactors": []
  },
  "10.41.1": {
    "date": "2025-06-18",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "new endpoints for organizations_table, grids working with new table schema"
    ]
  },
  "10.41.0": {
    "date": "2025-06-18",
    "Features": [
      "organizations now using pagination for grid"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "10.40.0": {
    "date": "2025-06-18",
    "Features": [
      "new typescript components for org datagrid"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "10.39.0": {
    "date": "2025-06-17",
    "Features": [
      "big refactor of organizations grid, new table ORGANIZATIONS_TABLE single dynamoDB design with organizations, deals, products in one"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "10.38.3": {
    "date": "2025-06-13",
    "Features": [],
    "Bug Fixes": [
      "onboarding status can now be updated in bulk or 1 at a time in the nco"
    ],
    "Style": [],
    "Refactors": []
  },
  "10.38.2": {
    "date": "2025-06-11",
    "Features": [],
    "Bug Fixes": [
      "organization bug with render objects component fixed"
    ],
    "Style": [],
    "Refactors": []
  },
  "10.38.1": {
    "date": "2025-06-10",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "fixed grid sizes for organization selection mtb"
    ],
    "Refactors": []
  },
  "10.38.0": {
    "date": "2025-06-10",
    "Features": [
      "updates to team reintroduced to mtb, this will update the organizations data as well, the organizations team and mtb team are the same data currently"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "10.37.1": {
    "date": "2025-06-10",
    "Features": [],
    "Bug Fixes": [
      "fixed loading for spend cells in mtb"
    ],
    "Style": [],
    "Refactors": []
  },
  "10.37.0": {
    "date": "2025-06-08",
    "Features": [
      "updates to MTB for efficiency, tasks are created automatically when the organization is accessed inside the mtb, progress will be recreated every month when accessed as well"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "10.36.0": {
    "date": "2025-06-04",
    "Features": [
      "updated read receipts to only be triggered when the comment is not owned by the current user, light indicator for unread comments"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "10.35.0": {
    "date": "2025-06-04",
    "Features": [
      "read receipts added to mtb"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "10.34.0": {
    "date": "2025-06-04",
    "Features": [
      "updates to active assignee working for mtb, uses team that is assigned in organizations for the assignee list"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "10.33.0": {
    "date": "2025-06-04",
    "Features": [
      "mtb grid comments now introduced"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "10.32.0": {
    "date": "2025-06-03",
    "Features": [
      "big updates to creating tasks and progress inside mtb, month is determined and if no tasks are created the logic will create new tasks and progress for that month, single and batch updates working efficiently"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "10.31.1": {
    "date": "2025-06-03",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "fixed placement of loading in nav bar to be consistent with new search component"
    ],
    "Refactors": []
  },
  "10.31.0": {
    "date": "2025-06-03",
    "Features": [
      "new search bar added to top navigation, use click or ctrl + shift + F to open. esc to close or click away"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "10.30.2": {
    "date": "2025-06-03",
    "Features": [],
    "Bug Fixes": [
      "fixed formatDayjsDateTime undefined error"
    ],
    "Style": [],
    "Refactors": []
  },
  "10.30.1": {
    "date": "2025-06-03",
    "Features": [],
    "Bug Fixes": [
      "fixed typeerrors for metric typescript files"
    ],
    "Style": [],
    "Refactors": []
  },
  "10.30.0": {
    "date": "2025-06-03",
    "Features": [
      "new views setup for monthly task board",
      "optimizations now dictate status availability based on the monthly task associated"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "10.29.6": {
    "date": "2025-06-01",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactors to rendermtbcolumns.tsx"
    ]
  },
  "10.29.5": {
    "date": "2025-05-31",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "fully type checked files for renderDealColumns and 75% of renderMtbColumns"
    ]
  },
  "10.29.4": {
    "date": "2025-05-30",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "columns refactored for MTB for efficiency and data fetching optimizations"
    ]
  },
  "10.29.3": {
    "date": "2025-05-30",
    "Features": [],
    "Bug Fixes": [
      "removed type from mass updates for organizations, fixed data types for other updates still included"
    ],
    "Style": [],
    "Refactors": []
  },
  "10.29.2": {
    "date": "2025-05-30",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "colors for clone and replace added more consistently"
    ],
    "Refactors": []
  },
  "10.29.1": {
    "date": "2025-05-30",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "revised global css styling and themes to correct type errors"
    ],
    "Refactors": []
  },
  "10.29.0": {
    "date": "2025-05-30",
    "Features": [
      "boards menu order is now customizable by drag and drop"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "10.28.2": {
    "date": "2025-05-30",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "complete refactor of renderDealsColumns using typescript and custom components, updated useQuery hooks and functions to optimize crud operations"
    ]
  },
  "10.28.1": {
    "date": "2025-05-29",
    "Features": [],
    "Bug Fixes": [
      "fixed onSettled bug with updateTaskItems query mutation"
    ],
    "Style": [],
    "Refactors": []
  },
  "10.28.0": {
    "date": "2025-05-28",
    "Features": [
      "new server side endpoints for creating progress items in monthly task board, seo, am, dms and overall progress tracking correctly"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "10.27.0": {
    "date": "2025-05-28",
    "Features": [
      "seo progress updating correctly"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "10.26.0": {
    "date": "2025-05-28",
    "Features": [
      "seo progress updating correctly"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "10.25.4": {
    "date": "2025-05-28",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "ancestor -> predecessor | descendant -> successor"
    ],
    "Refactors": []
  },
  "10.25.3": {
    "date": "2025-05-28",
    "Features": [],
    "Bug Fixes": [
      "cloning will reset deal to the correct state"
    ],
    "Style": [],
    "Refactors": []
  },
  "10.25.2": {
    "date": "2025-05-28",
    "Features": [],
    "Bug Fixes": [
      "cloning updates"
    ],
    "Style": [],
    "Refactors": []
  },
  "10.25.1": {
    "date": "2025-05-25",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "new hooks for data grids, task data grid updated"
    ]
  },
  "10.25.0": {
    "date": "2025-05-24",
    "Features": [
      "tree data for mtb enhanced"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "10.24.1": {
    "date": "2025-05-23",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "refactored code for efficient changes in form for cloning and creating deals"
    ]
  },
  "10.24.0": {
    "date": "2025-05-23",
    "Features": [
      "updates and revisions for efficiency for creating and cloning deals, mtb tree data started for test"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "10.23.0": {
    "date": "2025-05-21",
    "Features": [
      "major changes made for cloning and cloning and replacing current deals, highlight added when selecting a row for it's ancestor or descendant deal if they exist."
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "10.22.0": {
    "date": "2025-05-21",
    "Features": [
      "webhook now updates ancestor deal's status, end date, product start, end date and statuses when descendant deal is signed and deal won"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "10.21.1": {
    "date": "2025-05-20",
    "Features": [],
    "Bug Fixes": [
      "ensured organization vertical is always required even when using the create organization inside create deal"
    ],
    "Style": [],
    "Refactors": []
  },
  "10.21.0": {
    "date": "2025-05-20",
    "Features": [
      "deals can now be cloned from the deals grid and deals can be merged and replaced using the create deal component"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "10.20.1": {
    "date": "2025-05-20",
    "Features": [],
    "Bug Fixes": [
      "fixed height issues for optimizations items in MTB"
    ],
    "Style": [],
    "Refactors": []
  },
  "10.20.0": {
    "date": "2025-05-19",
    "Features": [
      "selecting a preexisting deal will now add a connection to the new deal created. This deal will contain the old id of the deal that will need to be replaced once the new contract is signed. Tooltip styling formatted for verticals and contacts in deal header and deal details"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "10.19.1": {
    "date": "2025-05-19",
    "Features": [],
    "Bug Fixes": [
      "review deal additional information now expanded by default"
    ],
    "Style": [],
    "Refactors": []
  },
  "10.19.0": {
    "date": "2025-05-17",
    "Features": [
      "script for updating product statuses created and product statuses now displayed in contracts"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "10.18.0": {
    "date": "2025-05-14",
    "Features": [
      "tracking type and tracking link updates and mass updates added to organizations"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "10.17.1": {
    "date": "2025-05-14",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "changes to status colors and roles colors"
    ],
    "Refactors": []
  },
  "10.17.0": {
    "date": "2025-05-14",
    "Features": [
      "checkbox renders inside the comments section using the rich text field will now correctly display when checked, using edit mode. styling corrected. Comments and attachments are only editable / deleted by the creator of the comment. Download all for social ads and display ads fixed, as well as missing information rendering in task details"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "10.16.0": {
    "date": "2025-05-13",
    "Features": [
      "subtask review process refactored and simplified"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "10.15.0": {
    "date": "2025-05-12",
    "Features": [
      "new notification and task creation added for when a PMC or OG is changed inside an organization"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "10.14.0": {
    "date": "2025-05-12",
    "Features": [
      "new checklists created for additional or existing domain updates in tasks"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "10.13.0": {
    "date": "2025-05-12",
    "Features": [
      "column widths now saving to localstorage, new step in team tasks help UI, new reset column widths button"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "10.12.2": {
    "date": "2025-05-09",
    "Features": [],
    "Bug Fixes": [
      "**organizations:** updating the organizations DBA/Legal Entity Name will now update the deals DBA correctly"
    ],
    "Style": [],
    "Refactors": []
  },
  "10.12.1": {
    "date": "2025-05-09",
    "Features": [],
    "Bug Fixes": [
      "**accounting:** fixed accounting drawer staying open after navigating to another url"
    ],
    "Style": [],
    "Refactors": []
  },
  "10.12.0": {
    "date": "2025-05-08",
    "Features": [
      "**accounting:** comments tab introduced to accounting board"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "10.11.0": {
    "date": "2025-05-08",
    "Features": [
      "**settings:** new settings options added for approvers"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "10.10.2": {
    "date": "2025-05-07",
    "Features": [],
    "Bug Fixes": [
      "fixed styling issues for text in light mode inside organization profile"
    ],
    "Style": [],
    "Refactors": []
  },
  "10.10.1": {
    "date": "2025-05-07",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "**OrganizationProfile:** added image rendering to fields when edit mode is not active"
    ],
    "Refactors": []
  },
  "10.10.0": {
    "date": "2025-05-06",
    "Features": [
      "**OrganizationProfile:** edit mode introduced"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "10.9.0": {
    "date": "2025-05-06",
    "Features": [
      "**notifications:** add Slack + app notifications for active subtask assignees"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "10.8.2": {
    "date": "2025-05-06",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "new notifications_table introduced with PK and SK, notifications bug with all notifications indicating unread has been fixed"
    ]
  },
  "10.8.1": {
    "date": "2025-05-06",
    "Features": [],
    "Bug Fixes": [
      "fixed blank screen on initial load for organization profile page"
    ],
    "Style": [],
    "Refactors": []
  },
  "10.8.0": {
    "date": "2025-05-06",
    "Features": [
      "batch and single creation for tasks now renders a selection list for subtasks that will be created. deselect subtasks to remove them from the list"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "10.7.0": {
    "date": "2025-05-05",
    "Features": [
      "subtask selection or deselection introduced when creating a single creative or marketing task"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "10.6.0": {
    "date": "2025-05-05",
    "Features": [
      "notifications will now be sent when changing active assignees inside the task drawer on close"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "10.5.0": {
    "date": "2025-05-03",
    "Features": [
      "nco comments w/ count added to grid, progress updated"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "10.4.3": {
    "date": "2025-05-02",
    "Features": [],
    "Bug Fixes": [
      "fixed errors when creating single or batch tasks, fixed mass delete bug, when mass deleting tasks or subtasks."
    ],
    "Style": [],
    "Refactors": []
  },
  "10.4.2": {
    "date": "2025-05-01",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "progress summary refactored for tasks and some updates for MTB"
    ]
  },
  "10.4.1": {
    "date": "2025-05-01",
    "Features": [],
    "Bug Fixes": [
      "fixed row expansion persistence"
    ],
    "Style": [],
    "Refactors": []
  },
  "10.4.0": {
    "date": "2025-05-01",
    "Features": [
      "introduced comments column with counts for tasks and subtasks, clicking the comment icon will navigate to the tasks or subtasks comment section"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "10.3.0": {
    "date": "2025-05-01",
    "Features": [
      "added floating edit, delete and cancel buttons to comments, fixed extra message count in subtask selector"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "10.2.2": {
    "date": "2025-05-01",
    "Features": [],
    "Bug Fixes": [
      "fixed focus issue when selecting edit for comments"
    ],
    "Style": [],
    "Refactors": []
  },
  "10.2.1": {
    "date": "2025-05-01",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "custom views added to team tasks"
    ],
    "Refactors": []
  },
  "10.2.0": {
    "date": "2025-04-30",
    "Features": [
      "edit mode for description in tasks introduced."
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "10.1.0": {
    "date": "2025-04-30",
    "Features": [
      "editing for comments introduced and refined, text only for now. Mass updating now only allows subtasks and tasks to be updated in groups, subtask assignee allows for one user at a time. mass delete will delete tasks, their subtasks, comments, attachments and thumbnails from data storage. New popover for mass delete will display counts for attachments and comments as well as the tasks name, and subtask names attached to the task"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "10.0.1": {
    "date": "2025-04-30",
    "Features": [],
    "Bug Fixes": [
      "single and mass updates for subtask assignee now only allow one user selection to match consistency for updates when inside task details"
    ],
    "Style": [],
    "Refactors": []
  },
  "10.0.0": {
    "date": "2025-04-30",
    "Features": [
      "comment text can now be updated in comment sections, new comments_table in dynamoDB, comments are created with their parent items primary key and a unique sort key."
    ],
    "Bug Fixes": [
      "new comments table."
    ],
    "Style": [],
    "Refactors": []
  },
  "9.4.2": {
    "date": "2025-04-29",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "fixed styling issues with floating info for marketing task form"
    ],
    "Refactors": []
  },
  "9.4.1": {
    "date": "2025-04-29",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "refactored contrast theme for more efficiency"
    ],
    "Refactors": []
  },
  "9.4.0": {
    "date": "2025-04-29",
    "Features": [
      "fixed subtask table height expanded or \\!expanded"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "9.3.3": {
    "date": "2025-04-28",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "hover effect test in organization column in team tasks, when hovered the column will display organization name"
    ],
    "Refactors": []
  },
  "9.3.2": {
    "date": "2025-04-26",
    "Features": [],
    "Bug Fixes": [
      "nco status change to bypass or awaiting kickoff nowcreating related task correctly"
    ],
    "Style": [],
    "Refactors": []
  },
  "9.3.1": {
    "date": "2025-04-26",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "task names for batch and single creation only include task type"
    ],
    "Refactors": []
  },
  "9.3.0": {
    "date": "2025-04-26",
    "Features": [
      "test tutorial helper introduced, icons based on selections rendered in team tasks items, names are now simplified, organization column introduced"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "9.2.0": {
    "date": "2025-04-26",
    "Features": [
      "new grayscale theme added"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "9.1.2": {
    "date": "2025-04-25",
    "Features": [],
    "Bug Fixes": [
      "gross profit for IO calculation fixed"
    ],
    "Style": [],
    "Refactors": []
  },
  "9.1.1": {
    "date": "2025-04-25",
    "Features": [],
    "Bug Fixes": [
      "mode and send review hidden until tested more"
    ],
    "Style": [],
    "Refactors": []
  },
  "9.1.0": {
    "date": "2025-04-25",
    "Features": [
      "checklists now generating when creating task type Campaign CChecklists, will render based on the platform and channels selected"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "9.0.0": {
    "date": "2025-04-24",
    "Features": [
      "New flow introduced for team tasks with queue, am approval",
      "introduced new filter buttons for team tasks."
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "8.8.0": {
    "date": "2025-04-22",
    "Features": [
      "Queue column added, when subtasks are attached the column displays the teams currently in queue for subtasks, each user selected in the queue will display a color coded border for the team they are on. Queue options are limited to the parent tasks current assignees. Task timeline created, currently creating entries for inline updates at the grid level, test columns for setting the task to review mode and passing the queue over to the AM implemented"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "8.7.3": {
    "date": "2025-04-22",
    "Features": [],
    "Bug Fixes": [
      "fixed animation error for pie charts in boards component"
    ],
    "Style": [],
    "Refactors": []
  },
  "8.7.2": {
    "date": "2025-04-22",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "**boards:** boards component now displaying pie chart for each board as well as total items in the board currently"
    ],
    "Refactors": []
  },
  "8.7.1": {
    "date": "2025-04-21",
    "Features": [],
    "Bug Fixes": [
      "default master status filter being applied correctly now in team tasks board"
    ],
    "Style": [],
    "Refactors": []
  },
  "8.7.0": {
    "date": "2025-04-21",
    "Features": [
      "added close button for floating row selection as well as hitting ESC to close delete popover or floating row selection"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "8.6.1": {
    "date": "2025-04-21",
    "Features": [],
    "Bug Fixes": [
      "team tasks board will render with a default filter that removes rows that contain a task that is in the master status Done"
    ],
    "Style": [],
    "Refactors": []
  },
  "8.6.0": {
    "date": "2025-04-21",
    "Features": [
      "queue column added for notifying who is up next on a specific task or subtask"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "8.5.1": {
    "date": "2025-04-21",
    "Features": [],
    "Bug Fixes": [
      "tasks grid data tree set to collapsed by default"
    ],
    "Style": [],
    "Refactors": []
  },
  "8.5.0": {
    "date": "2025-04-21",
    "Features": [
      "**tasks:** new column added Queue for assignment of next team member when task has many steps. Style adjusted for the update footer for team tasks board. Subtasks assignees, status and queue can be mass updated"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "8.4.0": {
    "date": "2025-04-20",
    "Features": [
      "**subtasks:** subtasks now properly nesting under parent task when created through task drawer."
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "8.3.0": {
    "date": "2025-04-17",
    "Features": [
      "creating tasks now also batch creating subtasks instead of checklists, these subtasks can be viewed in a data tree format in the datagrid. updates on the grid are working for status, start date and end date for subtasks currently."
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "8.2.0": {
    "date": "2025-04-16",
    "Features": [
      "**task/subtask:** s3 integration added to tasks and subtasks"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "8.1.0": {
    "date": "2025-04-16",
    "Features": [
      "selected tasks attachments can now be deleted as well as the full comment itself, which will also delete any attachments, pdf renders first page view of file and iframe added for viewing pdfs"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "8.0.0": {
    "date": "2025-04-15",
    "Features": [
      "s3 integration introduced to boards only.",
      "s3 integration introduced to boards, download single or all files, view files and navigate with arrow keys, delete single files, when note is deleted all attachments will also be deleted from DB."
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "7.10.0": {
    "date": "2025-04-15",
    "Features": [
      "dynamoDB integration with s3 and messages for boards"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "7.9.1": {
    "date": "2025-04-15",
    "Features": [],
    "Bug Fixes": [
      "fixed status warning for task master status inside task drawer"
    ],
    "Style": [],
    "Refactors": []
  },
  "7.9.0": {
    "date": "2025-04-15",
    "Features": [
      "organization details page update complete. All edited fields will be tracked and rendered at the bottom of the page, changes will not be made unless saved"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "7.8.1": {
    "date": "2025-04-14",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "added hook for sending and creating notifications"
    ]
  },
  "7.8.0": {
    "date": "2025-04-14",
    "Features": [
      "notifications added to subtasks"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "7.7.0": {
    "date": "2025-04-14",
    "Features": [
      "organization details updated for user feedback when entering new values, and to only change values when saving"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "7.6.0": {
    "date": "2025-04-11",
    "Features": [
      "changing nco status to bypass will now filter out the current item from the nco board and created a follow up task, using any other status ensures that it is not filtered out"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "7.5.1": {
    "date": "2025-04-11",
    "Features": [],
    "Bug Fixes": [
      "nco onboarding status updates reflecting correctly now"
    ],
    "Style": [],
    "Refactors": []
  },
  "7.5.0": {
    "date": "2025-04-11",
    "Features": [
      "assignees, start and due date added to new subtasks"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "7.4.1": {
    "date": "2025-04-11",
    "Features": [],
    "Bug Fixes": [
      "server clean up, keys for created checklists fixed"
    ],
    "Style": [],
    "Refactors": []
  },
  "7.4.0": {
    "date": "2025-04-10",
    "Features": [
      "added created time to new subtasks and tasks, checklists sort by created time starting with the most recent"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "7.3.1": {
    "date": "2025-04-10",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "set global styling for select components for when values are selected"
    ],
    "Refactors": []
  },
  "7.3.0": {
    "date": "2025-04-10",
    "Features": [
      "subtask selection added to task messages, checklists can be created using the new checklist item input and plus icon. routing updated between tasks and their affiliated boards"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "7.2.2": {
    "date": "2025-04-10",
    "Features": [],
    "Bug Fixes": [
      "fixed height for better viewing in review deal inside board drawers"
    ],
    "Style": [],
    "Refactors": []
  },
  "7.2.1": {
    "date": "2025-04-10",
    "Features": [],
    "Bug Fixes": [
      "fixed error when no checklists exist for task drawer"
    ],
    "Style": [],
    "Refactors": []
  },
  "7.2.0": {
    "date": "2025-04-09",
    "Features": [
      "batch creation for digital tasks added, progress for creative tasks added"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "7.1.1": {
    "date": "2025-04-09",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "main tab for creative projects is now displaying buttons to create a single or multiple tasks and displays the list of current tasks for the project"
    ],
    "Refactors": []
  },
  "7.1.0": {
    "date": "2025-04-09",
    "Features": [
      "**tasks:** huge feature added for batch creation of tasks from board items. component will bring in organization data and user has access to editing all fields just like the creation of a single task"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "7.0.0": {
    "date": "2025-04-08",
    "Features": [
      "Drawer Task Grid removed and Buttons added for creating tasks quickly and efficiently",
      "New component to create tasks quickly, comments sections in each item now directly linked to tasks created for organization. MTB updates to team working correctly."
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "6.40.0": {
    "date": "2025-04-07",
    "Features": [
      "converted batch update to typescript, MTB team updates now working and synchronized with the organizations team at the top level"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "6.39.1": {
    "date": "2025-04-06",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "create dialogs errors displayed in a more efficient manner, consistent styling throughout"
    ],
    "Refactors": []
  },
  "6.39.0": {
    "date": "2025-04-04",
    "Features": [
      "attachments added to creative task form, kick off call task now creating with more data, filters for task by organization added.. creative tasks filtered in creative board etc."
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "6.38.1": {
    "date": "2025-04-04",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "fixed styling with task types in taskbyorganization component"
    ],
    "Refactors": []
  },
  "6.38.0": {
    "date": "2025-04-03",
    "Features": [
      "footer for tasks that contains attachments and plus icon for adding more attachments. Ad approvals tasks will render with a checklist"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "6.37.0": {
    "date": "2025-04-03",
    "Features": [
      "can now attach images and files when creating task correctly, when deleting a task all attachments are also deleted from s3 bucket"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "6.36.0": {
    "date": "2025-04-02",
    "Features": [
      "attachments when creating and updating tasks in team tasks added. Filter for task type added. Ad Apprvals, Campaign Checklists, Pause, Enable task types added."
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "6.35.0": {
    "date": "2025-03-31",
    "Features": [
      "new board: Campaign Checklists"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "6.34.8": {
    "date": "2025-03-31",
    "Features": [],
    "Bug Fixes": [
      "fixed field updates for integration tab NCO"
    ],
    "Style": [],
    "Refactors": []
  },
  "6.34.7": {
    "date": "2025-03-29",
    "Features": [],
    "Bug Fixes": [
      "single updates for assignees in team tasks now working correctly"
    ],
    "Style": [],
    "Refactors": []
  },
  "6.34.6": {
    "date": "2025-03-29",
    "Features": [],
    "Bug Fixes": [
      "fixed inconsistent loading for mtb data grid"
    ],
    "Style": [],
    "Refactors": []
  },
  "6.34.5": {
    "date": "2025-03-29",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "cleaned up excess code in routing"
    ]
  },
  "6.34.4": {
    "date": "2025-03-28",
    "Features": [],
    "Bug Fixes": [
      "fixed dealStatus filter for cancelled"
    ],
    "Style": [],
    "Refactors": []
  },
  "6.34.3": {
    "date": "2025-03-28",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "replaced links for deal name, org name and contracted by name with navigate logic to remove browser link on hover"
    ],
    "Refactors": []
  },
  "6.34.2": {
    "date": "2025-03-28",
    "Features": [],
    "Bug Fixes": [
      "changed expired statuses to Ended and notifications for status updates now working"
    ],
    "Style": [],
    "Refactors": []
  },
  "6.34.1": {
    "date": "2025-03-28",
    "Features": [],
    "Bug Fixes": [
      "when creating new organization from create deal dialog, contracted by and affiliated lists now populate correctly, assigning new owners to contacts fixed"
    ],
    "Style": [],
    "Refactors": []
  },
  "6.34.0": {
    "date": "2025-03-27",
    "Features": [
      "metrics data grid created, simple digital tasks can be created for all task types using the digital task form"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "6.33.0": {
    "date": "2025-03-27",
    "Features": [
      "metrics table prototype created with python script for new products_table that will contain deals products as separate items"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "6.32.1": {
    "date": "2025-03-26",
    "Features": [],
    "Bug Fixes": [
      "fixed base url for routing from slack message link"
    ],
    "Style": [],
    "Refactors": []
  },
  "6.32.0": {
    "date": "2025-03-26",
    "Features": [
      "urls added to slack notifications when tagging a user in a message"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "6.31.2": {
    "date": "2025-03-26",
    "Features": [],
    "Bug Fixes": [
      "fixed routing and view change for mtb notifications and mtb drawer"
    ],
    "Style": [],
    "Refactors": []
  },
  "6.31.1": {
    "date": "2025-03-25",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "revised the task selector list to be more consistent when rendering the name, identifier and comments length"
    ],
    "Refactors": []
  },
  "6.31.0": {
    "date": "2025-03-25",
    "Features": [
      "identifiers added to task list for selection when creating a new comment"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "6.30.0": {
    "date": "2025-03-25",
    "Features": [
      "organizations filtered by active statuses and active deals"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "6.29.0": {
    "date": "2025-03-25",
    "Features": [
      "MTB now using organizations as the foundation for data, optimizations are now listed in the task list for the notes comments section"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "6.28.5": {
    "date": "2025-03-24",
    "Features": [],
    "Bug Fixes": [
      "fixed height for deals kanban and stages not updating correctly"
    ],
    "Style": [],
    "Refactors": []
  },
  "6.28.4": {
    "date": "2025-03-24",
    "Features": [],
    "Bug Fixes": [
      "statuses and task types will now immediately update on selection of a new status"
    ],
    "Style": [],
    "Refactors": []
  },
  "6.28.3": {
    "date": "2025-03-24",
    "Features": [],
    "Bug Fixes": [
      "fixed routing in dealskanban, no signature checkbox now functioning correctly in create deal, team members can be updated using single or mass updates in team tasks"
    ],
    "Style": [],
    "Refactors": []
  },
  "6.28.2": {
    "date": "2025-03-21",
    "Features": [],
    "Bug Fixes": [
      "webhook error fixed for CSA contracts"
    ],
    "Style": [],
    "Refactors": []
  },
  "6.28.1": {
    "date": "2025-03-21",
    "Features": [],
    "Bug Fixes": [
      "updates for assignees on task board now working properly, fixed routing to organizations and contacts from deals"
    ],
    "Style": [],
    "Refactors": []
  },
  "6.28.0": {
    "date": "2025-03-17",
    "Features": [
      "scrolling added to review deal collapsible section"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "6.27.1": {
    "date": "2025-03-14",
    "Features": [],
    "Bug Fixes": [
      "removed deals routing from boards navigation component"
    ],
    "Style": [],
    "Refactors": []
  },
  "6.27.0": {
    "date": "2025-03-14",
    "Features": [
      "digital task options added for creation"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "6.26.0": {
    "date": "2025-03-14",
    "Features": [
      "notification urls for comments made in task selections will navigate to the selected task comments section and select the task automatically"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "6.25.0": {
    "date": "2025-03-13",
    "Features": [
      "comments now contain task selection for the general task list, when selected the comments will be filtered to display only the list from the task itself, as well as when submitting a new comment on a selected task the selection will dictate where the comment is populated. Creating a new task in the general list will populate this selection with that task and comments can be added."
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "6.24.0": {
    "date": "2025-03-12",
    "Features": [
      "custom checklists now rendering specifically for each board when created, as well as auto created checklists"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "6.23.0": {
    "date": "2025-03-12",
    "Features": [
      "website board and drawer now efficiently syncing, need to optimize checklist auto create on initial render"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "6.22.0": {
    "date": "2025-03-11",
    "Features": [
      "creative checklists auto creating and new project info tab renders fields based on services contracted"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "6.21.2": {
    "date": "2025-03-06",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "fixed height issues with task messages"
    ],
    "Refactors": []
  },
  "6.21.1": {
    "date": "2025-03-06",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "fixed sizing of multiple attachments for notes and added transform, tooltips with file names and tagged users names"
    ],
    "Refactors": []
  },
  "6.21.0": {
    "date": "2025-03-06",
    "Features": [
      "multiple file attachments for notes sections added"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "6.20.0": {
    "date": "2025-03-06",
    "Features": [
      "am progress, dms progress, activeDeals svg progress, billing contacts, am & dms task list tabs, digital and seo optimizations added to MTB, new board: MTB"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "6.19.0": {
    "date": "2025-03-05",
    "Features": [
      "checklist creation added to boards, checklist items can be added or deleted and new task lists can be created as well"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "6.18.0": {
    "date": "2025-03-04",
    "Features": [
      "website & creative task lists being created dynamically, as well as equipment checklist for photo and video shoots, progress for website and creative on separate tabs"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "6.17.1": {
    "date": "2025-03-03",
    "Features": [],
    "Bug Fixes": [
      "scrollbar appears for larger tooltips in the optimizations autocomplete"
    ],
    "Style": [],
    "Refactors": []
  },
  "6.17.0": {
    "date": "2025-03-03",
    "Features": [
      "Seo optimizations added, create and edit new optimizations from list imported from seo templates"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "6.16.0": {
    "date": "2025-03-02",
    "Features": [
      "progress bars added to board drawers and column after organizaation in SEO and NCO"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "6.15.0": {
    "date": "2025-03-02",
    "Features": [
      "checklists dynamically generating and efficiently batch updating as well as updating channel headers, added buildTier, hostTier to website board"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "6.14.0": {
    "date": "2025-03-01",
    "Features": [
      "seo checklists"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "6.13.0": {
    "date": "2025-03-01",
    "Features": [
      "team members, assignees, and assigner columns added to task boards and nco, seo"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "6.12.0": {
    "date": "2025-02-28",
    "Features": [
      "seo board features beginning, mass updates and inline update functionality needs revising"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "6.11.0": {
    "date": "2025-02-27",
    "Features": [
      "task messages added to newly created tasks, when a task is created the task folder is also created inside the organizations task folder in google drive"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "6.10.1": {
    "date": "2025-02-25",
    "Features": [],
    "Bug Fixes": [
      "fixed task drawers open state for navigation and when visiting links, drawers will open when links are navigated to and closes correctly navigating back to the grid"
    ],
    "Style": [],
    "Refactors": []
  },
  "6.10.0": {
    "date": "2025-02-25",
    "Features": [
      "creative tasks board created, user image is now used for filtering my items"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "6.9.0": {
    "date": "2025-02-25",
    "Features": [
      "top right nav button added and view state synchronized with other route navigations"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "6.8.0": {
    "date": "2025-02-24",
    "Features": [
      "mass updates for team tasks working well, refactor of filter buttons and layout for each grid"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "6.7.0": {
    "date": "2025-02-23",
    "Features": [
      "creative intake form added, mass updates for high prio working, need to refactor and optimize mass updates for task fields in team tasks"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "6.6.0": {
    "date": "2025-02-22",
    "Features": [
      "boards navigation added, hierarchy for task checklist in nco"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "6.5.0": {
    "date": "2025-02-21",
    "Features": [
      "navBar moved to the top of page, fixed refresh error in boards drawer component"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "6.4.0": {
    "date": "2025-02-20",
    "Features": [
      "search bar stays focused when being used to navigate to different modules, updated routes"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "6.3.0": {
    "date": "2025-02-19",
    "Features": [
      "checklists now updating organizations and state correctly"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "6.2.0": {
    "date": "2025-02-19",
    "Features": [
      "attach button for input that will attach files from google drive to the list of comments, thumbnail will be rendered and when clicking will open an iframe of the document with close button and a link to view in google drive"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "6.1.0": {
    "date": "2025-02-18",
    "Features": [
      "new rich text with tagging added to the boards components for communication during onboarding"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "6.0.0": {
    "date": "2025-02-17",
    "Features": [
      "New floating navigation bar",
      "new navigation introduced with floating navigation bar, deals details can be navigated once accessed by choosing a new deal"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "5.10.0": {
    "date": "2025-02-15",
    "Features": [
      "integration checklist added with new icons for ga4, gtm, google search"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "5.9.0": {
    "date": "2025-02-14",
    "Features": [
      "integration checklist added to board drawers"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "5.8.0": {
    "date": "2025-02-14",
    "Features": [
      "handoff call form available inside organization item in the nco, document will be created from template and added inside of organizations google drive folder"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "5.7.0": {
    "date": "2025-02-14",
    "Features": [
      "task is now created when onboarding status in nco is changed to awaiting kickoff, team tasks board optimizations: introduced more editable cells, task days and date due are calculating correctly, assigning new users is triggering notifications"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "5.6.0": {
    "date": "2025-02-13",
    "Features": [
      "google drive folders added to organizations tab display and NCO tab display for deals, single folder only for each."
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "5.5.1": {
    "date": "2025-02-13",
    "Features": [],
    "Bug Fixes": [
      "fixed contracted by not rendering in new boards"
    ],
    "Style": [],
    "Refactors": []
  },
  "5.5.0": {
    "date": "2025-02-13",
    "Features": [
      "extending file management to board drawers and setup all boards except MTB so far"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "5.4.1": {
    "date": "2025-02-11",
    "Features": [],
    "Bug Fixes": [
      "fixed search functionality for owners in nco"
    ],
    "Style": [],
    "Refactors": []
  },
  "5.4.0": {
    "date": "2025-02-11",
    "Features": [
      "multiselect filters for type now working as expected in organizations grid"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "5.3.2": {
    "date": "2025-02-10",
    "Features": [],
    "Bug Fixes": [
      "dealStatus now updating correctly inside deal details"
    ],
    "Style": [],
    "Refactors": []
  },
  "5.3.1": {
    "date": "2025-02-10",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "5.3.0": {
    "date": "2025-02-07",
    "Features": [
      "google drive apis created to create a single folder and create a parent folder with multiple subfolders"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "5.2.0": {
    "date": "2025-02-07",
    "Features": [
      "google drive hierarchy added to organizations, google picker component will be rendered per folder and uploads/downloads will be available directly in each folder."
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "5.1.0": {
    "date": "2025-02-06",
    "Features": [
      "google picker now refreshes access token when needed, new script for bulk creation of deals"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "5.0.0": {
    "date": "2025-02-06",
    "Features": [
      "The Picker now maintains folder state after uploads, which changes previous navigation behavior. Folder selection is currently available but may change in the future",
      "refactored Google Picker handling"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "4.7.0": {
    "date": "2025-02-06",
    "Features": [
      "google driver picker component feature added. View, download, upload"
    ],
    "Bug Fixes": [
      "fix organization owners not updating correctly"
    ],
    "Style": [],
    "Refactors": []
  },
  "4.6.1": {
    "date": "2025-02-05",
    "Features": [],
    "Bug Fixes": [
      "deal won stage now displaying totals for specific deals in pipeline"
    ],
    "Style": [],
    "Refactors": []
  },
  "4.6.0": {
    "date": "2025-02-04",
    "Features": [
      "reassigning recipients for the pandadoc contract now available. If contact does not exist in pandadoc, the contact will be created and updated."
    ],
    "Bug Fixes": [
      "contact recipient link updated not to show when the contract has been reverted to draft"
    ],
    "Style": [],
    "Refactors": []
  },
  "4.5.0": {
    "date": "2025-02-03",
    "Features": [
      "when creating a deal, hitting next will navigate to the newly created deal for editing, in the dealspage grid, clicking the edit icon will navigate to the agreement of the selected deal instead of rendering a dialog component"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "4.4.0": {
    "date": "2025-02-03",
    "Features": [
      "multi select filters now in organizations and deals"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "4.3.2": {
    "date": "2025-02-03",
    "Features": [],
    "Bug Fixes": [
      "bug from team members autocomplete"
    ],
    "Style": [],
    "Refactors": []
  },
  "4.3.1": {
    "date": "2025-01-30",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "new layout for dr deals details completed, screen size defined for macbook pro"
    ],
    "Refactors": []
  },
  "4.3.0": {
    "date": "2025-01-29",
    "Features": [
      "new layout for deals details and new fields for editing - owner, dealStatus, invoiceOption, agreementOption, pipeline stage, probability"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "4.2.6": {
    "date": "2025-01-27",
    "Features": [],
    "Bug Fixes": [
      "gross profit currently updating when viewing deals in details and review, need to update globally"
    ],
    "Style": [],
    "Refactors": []
  },
  "4.2.5": {
    "date": "2025-01-23",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "edit buttons added for smaller screen sizes when viewing the product list inside contracts"
    ],
    "Refactors": []
  },
  "4.2.4": {
    "date": "2025-01-22",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "xl, lg, md, sm & xs screen sizes optimized"
    ],
    "Refactors": []
  },
  "4.2.3": {
    "date": "2025-01-22",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "4.2.2": {
    "date": "2025-01-21",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "xl and lg screen sizes optimized"
    ],
    "Refactors": []
  },
  "4.2.1": {
    "date": "2025-01-21",
    "Features": [],
    "Bug Fixes": [
      "when contract is saved, if either recipient has changed, the contract is now being updated correctly, only for 1 recipient each"
    ],
    "Style": [],
    "Refactors": []
  },
  "4.2.0": {
    "date": "2025-01-20",
    "Features": [
      "contracts now no longer setting a signing order on creation and update so links will not require one or the other to finish signing the document before signing themselves."
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "4.1.0": {
    "date": "2025-01-17",
    "Features": [
      "generate links, revert to draft, view links, save & update functions added to deals contracts. Deals can now update entire contract data, send the contract, change authorized and contact recipients."
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "4.0.3": {
    "date": "2025-01-16",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "4.0.2": {
    "date": "2025-01-16",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "styling fixes for CSA type contract"
    ],
    "Refactors": []
  },
  "4.0.1": {
    "date": "2025-01-15",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "4.0.0": {
    "date": "2025-01-15",
    "Features": [
      "new contract functionally including updates to pandadoc, changing document from any status to draft, and link generation"
    ],
    "Bug Fixes": [],
    "Style": [
      "this is a completely new flow for creating, saving and generating contracts"
    ],
    "Refactors": []
  },
  "3.4.7": {
    "date": "2025-01-14",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "completely new structure to the deals contracts page"
    ],
    "Refactors": []
  },
  "3.4.6": {
    "date": "2025-01-14",
    "Features": [],
    "Bug Fixes": [
      "PandaDoc webhook ip addresses added to allowed list."
    ],
    "Style": [],
    "Refactors": []
  },
  "3.4.5": {
    "date": "2025-01-13",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "fixed scrolling issues inside NCO drawer for strategy tab and review deal"
    ],
    "Refactors": []
  },
  "3.4.4": {
    "date": "2025-01-10",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "replaced single get requests with batch requests for all get apis"
    ]
  },
  "3.4.3": {
    "date": "2025-01-09",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "major changes to server side rendering and queries being invalidated"
    ]
  },
  "3.4.2": {
    "date": "2025-01-08",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "more optimizations for react query"
    ]
  },
  "3.4.1": {
    "date": "2025-01-07",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "grid and dependencies cards reacting to screen size"
    ],
    "Refactors": []
  },
  "3.4.0": {
    "date": "2025-01-06",
    "Features": [
      "adding update functionality to pandadoc contracts via grobotic"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "3.3.4": {
    "date": "2025-01-03",
    "Features": [],
    "Bug Fixes": [
      "fixed routing issue with nco drawer tabs"
    ],
    "Style": [],
    "Refactors": []
  },
  "3.3.3": {
    "date": "2025-01-02",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "optimizations for react query"
    ]
  },
  "3.3.2": {
    "date": "2024-12-19",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "temporary fix for smaller screens in the contract screen"
    ],
    "Refactors": []
  },
  "3.3.1": {
    "date": "2024-12-16",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "updating padding and alignment for strategy inside nco"
    ],
    "Refactors": []
  },
  "3.3.0": {
    "date": "2024-12-16",
    "Features": [
      "strategy now included in the Nco details drawer, drawer updated with links to each component including campaigns"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "3.2.2": {
    "date": "2024-12-16",
    "Features": [],
    "Bug Fixes": [
      "organization team will update correctly now, and will notify the team member assigned to the role upon updating"
    ],
    "Style": [],
    "Refactors": []
  },
  "3.2.1": {
    "date": "2024-12-13",
    "Features": [],
    "Bug Fixes": [
      "central time and eastern time will now synchronize with dates correctly, in the create deal screen keyboard input is now available for start and end date"
    ],
    "Style": [],
    "Refactors": []
  },
  "3.2.0": {
    "date": "2024-12-13",
    "Features": [
      "light mode/dark mode will now remain set. descriptions added to accounting drawer, click on description icon and click the copy icon to copy the products description"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "3.1.3": {
    "date": "2024-12-12",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "accounting drawer header styling revised, more data added"
    ],
    "Refactors": []
  },
  "3.1.2": {
    "date": "2024-12-11",
    "Features": [],
    "Bug Fixes": [
      "contact first name, middle name, and last name will now be the place for updating the contacts name and will reflect correctly. fixed recalculations in accounting grid"
    ],
    "Style": [],
    "Refactors": []
  },
  "3.1.1": {
    "date": "2024-12-10",
    "Features": [],
    "Bug Fixes": [
      "dial menu rendering now even when unread notifications don't exist"
    ],
    "Style": [],
    "Refactors": []
  },
  "3.1.0": {
    "date": "2024-12-10",
    "Features": [
      "views now available in the accounting board for invoice, billing, and churn"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "3.0.0": {
    "date": "2024-12-10",
    "Features": [
      "Notifications and Toggle for light and dark now are contained in the user profile icon.",
      "New speed dial for notifications, toggle light and dark mode, and settings"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "2.30.0": {
    "date": "2024-12-09",
    "Features": [
      "new speed dial component added to application for changing light and dark mode, viewing notifications and settings"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "2.29.2": {
    "date": "2024-12-05",
    "Features": [],
    "Bug Fixes": [
      "fixed primary and billing contacts not rendering, billing contact is now automatically created when the deal is won using the information that was filled out by the client"
    ],
    "Style": [],
    "Refactors": []
  },
  "2.29.1": {
    "date": "2024-12-05",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "new products added Expedited Launch, Expedited Creative Launch, Expedited Website Launch"
    ]
  },
  "2.29.0": {
    "date": "2024-12-04",
    "Features": [
      "**tags:** new custom input created for tagging users using the @ symbol"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "2.28.0": {
    "date": "2024-12-02",
    "Features": [
      "**NCO:** role assignments, tasks and dependencies now rendering and editable for each deal in the nco"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "2.27.0": {
    "date": "2024-12-02",
    "Features": [
      "**nco:** more editing updates for NCO grid and optimized sorting, filtering and resetting"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "2.26.0": {
    "date": "2024-11-27",
    "Features": [
      "**NCO:** nco board development begins. Inline editing of Nco Status, Est. Launch Date and Dependencies Due Date currently implemented"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "2.25.0": {
    "date": "2024-11-20",
    "Features": [
      "start of notifications development"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "2.24.0": {
    "date": "2024-11-19",
    "Features": [
      "**accounting:** organization and deal information added to accounting drawer"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "2.23.0": {
    "date": "2024-11-18",
    "Features": [
      "**accounting:** single updates and mass updates for the invoice status is now available, clicking on the deal name in the grid will open the invoice details for that deal"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "2.22.0": {
    "date": "2024-11-15",
    "Features": [
      "**boards:** new accounting board added with minimal features, will be updating filters and specific cell editing, clicking the deal will navigate to review, clicking the pandadoc icon will display the current contract attached to the deal and allow for downloading."
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "2.21.0": {
    "date": "2024-11-15",
    "Features": [
      "validation for strategy added, still needs more fields and small revisions"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "2.20.1": {
    "date": "2024-11-14",
    "Features": [],
    "Bug Fixes": [
      "when navigating to campaigns using the campaign icon, new campaigns will now be created and successfully rendered without error"
    ],
    "Style": [],
    "Refactors": []
  },
  "2.20.0": {
    "date": "2024-11-13",
    "Features": [
      "functionality for adding and removing campaigns, as well as adding adsets to social campaigns"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "2.19.0": {
    "date": "2024-11-13",
    "Features": [
      "strategy campaigns are now creating upon accessing them within the product list, they can be edited"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "2.18.0": {
    "date": "2024-11-11",
    "Features": [
      "campaigns now rendering using the campaign icon on each service selected for the strategy"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "2.17.0": {
    "date": "2024-11-08",
    "Features": [
      "campaigns are now accessibly through the campaign icon rendered on each product in the strategy"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "2.16.0": {
    "date": "2024-11-07",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "updated strategy product prices to change color and value when the payer is assigned as client"
    ],
    "Refactors": []
  },
  "2.15.0": {
    "date": "2024-11-07",
    "Features": [
      "strategy is efficiently being created for each deal when the strategy tab is accessed. Updates stay synced with organization details and deal details, as well as the addition or removal of products. When deal is deleted the strategy is deleted as well."
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "2.14.5": {
    "date": "2024-11-07",
    "Features": [],
    "Bug Fixes": [
      "strategy line items now adding and removing properly based on the deals contract"
    ],
    "Style": [],
    "Refactors": []
  },
  "2.14.4": {
    "date": "2024-11-05",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "added color change for billed price when the payer has been set to Client inside the contract"
    ],
    "Refactors": []
  },
  "2.14.3": {
    "date": "2024-11-05",
    "Features": [],
    "Bug Fixes": [
      "optimized contract totals, added time column for timeline and simplified rendering details"
    ],
    "Style": [],
    "Refactors": []
  },
  "2.14.2": {
    "date": "2024-11-05",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "updated views for approvers in the review deal tab in deals details."
    ],
    "Refactors": []
  },
  "2.14.1": {
    "date": "2024-11-04",
    "Features": [],
    "Bug Fixes": [
      "fixed render of monthly total for msa rmsa when dates are the same and or dates are different"
    ],
    "Style": [],
    "Refactors": []
  },
  "2.14.0": {
    "date": "2024-11-01",
    "Features": [
      "deal type change will now trigger a new approval process each time, all contracts will trigger a request for approval"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "2.13.0": {
    "date": "2024-10-31",
    "Features": [
      "admin approvals now working with individual approval elements"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "2.12.0": {
    "date": "2024-10-31",
    "Features": [
      "approvals now triggered for all deals"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "2.11.0": {
    "date": "2024-10-25",
    "Features": [
      "approval process in place, still need to revise admin privileges and custom approvers"
    ],
    "Bug Fixes": [],
    "Style": [
      "updated approver background for light theme in review deal component"
    ],
    "Refactors": []
  },
  "2.10.1": {
    "date": "2024-10-23",
    "Features": [],
    "Bug Fixes": [
      "fixed missing data from edit dialog for deals in deals grid"
    ],
    "Style": [],
    "Refactors": []
  },
  "2.10.0": {
    "date": "2024-10-22",
    "Features": [
      "new timeline for approvals is now inside the deal details page, this will currently display different actions taken during the approval process and will also display the initial creation of a deal once a deal is created after this feature"
    ],
    "Bug Fixes": [],
    "Style": [
      "added deal status to deals grid"
    ],
    "Refactors": []
  },
  "2.9.0": {
    "date": "2024-10-18",
    "Features": [
      "**approvals:** approvals board now renders approvers who are directly assigned to the deal as well as their current status of approval",
      "**CSA Deals:** number of payments will default to 1 when the contract total is less than or equal to 2500. When the total is greater than 2500 the default will be set to 2 and the option to change the number of payments will become available",
      "rejecting and resolving deals in approvals working correctly and updating the page after interaction approvals page now contains the assigned approvers with their status as a badge displayed",
      "**release:** changelog updated and version release 2.6.1",
      "**release:** changelog updates and version release",
      "**release:** changelog updates and version release 2.6.0",
      "strategy products populate based on selection, unique fields are generated for each product whether it is two of the same or all different"
    ],
    "Bug Fixes": [
      "manual changelog adjustments",
      "**strategy:** fixed edits and rendering of selected products inside strategy"
    ],
    "Style": [
      "layout change in review deal page for new approval process"
    ],
    "Refactors": []
  },
  "2.8.0": {
    "date": "2024-10-17",
    "Features": [
      "**CSA Deals:** number of payments will default to 1 when the contract total is less than or equal to 2500. When the total is greater than 2500 the default will be set to 2 and the option to change the number of payments will become available",
      "**release:** changelog updates and version release",
      "strategy products populate based on selection, unique fields are generated for each product whether it is two of the same or all different"
    ],
    "Bug Fixes": [
      "manual changelog adjustments",
      "**strategy:** fixed edits and rendering of selected products inside strategy"
    ],
    "Style": [
      "layout change in review deal page for new approval process",
      "layout change in review deal page for new approval process"
    ],
    "Refactors": []
  },
  "2.7.0": {
    "date": "2024-10-17",
    "Features": [
      "strategy products populate based on selection, unique fields are generated for each product whether it is two of the same or all different"
    ],
    "Bug Fixes": [
      "**strategy:** fixed edits and rendering of selected products inside strategy"
    ],
    "Style": [
      "layout change in review deal page for new approval process"
    ],
    "Refactors": []
  },
  "2.6.4": {
    "date": "2024-10-17",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "**release:** changelog updates and version release"
    ],
    "Refactors": []
  },
  "2.6.3": {
    "date": "2024-10-17",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "**release:** changelog updates and version release"
    ],
    "Refactors": []
  },
  "2.6.2": {
    "date": "2024-10-11",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "**release:** changelog updated and version release 2.6.1"
    ],
    "Refactors": []
  },
  "2.6.1": {
    "date": "2024-10-08",
    "Features": [],
    "Bug Fixes": [
      "**release:** changelog updates and version release 2.6.0",
      "**strategy:** fixed edits and rendering of selected products inside strategy"
    ],
    "Style": [],
    "Refactors": []
  },
  "2.6.0": {
    "date": "2024-10-07",
    "Features": [
      "**CSA Deals:** number of payments will default to 1 when the contract total is less than or equal to 2500. When the total is greater than 2500 the default will be set to 2 and the option to change the number of payments will become available"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "2.5.0": {
    "date": "2024-10-04",
    "Features": [
      "**approvals update:** the authorized approvers are now rendered in the row with the deal that needs approval, use the different sorting buttons to view all approvals ie. completed or open, as well as deals you have approved, the my approvals filter will also filter deals that require your approval in the near future. The initial filter is set to show only open approvals"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "2.4.1": {
    "date": "2024-10-04",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "**Grid Updates:** reset buttons are more interactive and will enable and disable based on whether filters, sorting or column visibility has been changed"
    ],
    "Refactors": []
  },
  "2.4.0": {
    "date": "2024-10-03",
    "Features": [
      "approval board now available for keeping track of when deal approvals are requested and approved"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "2.3.0": {
    "date": "2024-09-27",
    "Features": [
      "sorting and column visibility will now be saved on change in organizations, deals and contacts. Use the reset buttons to clear the visibility and sorting back to default"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "2.2.6": {
    "date": "2024-09-27",
    "Features": [],
    "Bug Fixes": [
      "when creating a new organization from the create deal screen, the organization will now save correctly and be added as the selected organization for the new deal. All deals that have been created should now filter correctly using the search bar or other filters"
    ],
    "Style": [],
    "Refactors": []
  },
  "2.2.5": {
    "date": "2024-09-25",
    "Features": [],
    "Bug Fixes": [
      "**update:** fixed scrolling issue in invoices for deals and statuses should remain more synchronized with deals and their related contracts"
    ],
    "Style": [],
    "Refactors": []
  },
  "2.2.4": {
    "date": "2024-09-25",
    "Features": [],
    "Bug Fixes": [
      "fixed deal status changing when loading into contract, discovery fields correctly identifying when social profiles are assigned by entering the website into organization's website"
    ],
    "Style": [],
    "Refactors": []
  },
  "2.2.3": {
    "date": "2024-09-23",
    "Features": [],
    "Bug Fixes": [
      "deals kanban available again clicking the icon in the top left of the deals grid view"
    ],
    "Style": [],
    "Refactors": []
  },
  "2.2.2": {
    "date": "2024-09-23",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "added tooltip for deals details header on status and changed status color to background for easier viewing"
    ],
    "Refactors": []
  },
  "2.2.1": {
    "date": "2024-09-20",
    "Features": [],
    "Bug Fixes": [
      "**update:** strategy tab will be available in the next version of grobotic"
    ],
    "Style": [],
    "Refactors": []
  },
  "2.2.0": {
    "date": "2024-09-20",
    "Features": [
      "**navigation:** remove top navbar and consolidate to left navigation",
      "the strategy tab is now available and has a notes section for communication throughout the onboarding process",
      "**update:** added new vertical mortgage to vertical list, fixed loading bug with notes rich text field"
    ],
    "Bug Fixes": [
      "**navigation:** The top navbar has been removed and the navigation is now consolidated to the left. The theme toggle was replaced with icons to toggle the theme upon click. The create menu, theme toggle, user image and patch notes are located in the bottom of left of the navigationbar",
      "fixed approval button not appearing when request was made"
    ],
    "Style": [],
    "Refactors": []
  },
  "1.25.5": {
    "date": "2024-09-19",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "aligned menu items and fix: fixed deal white screen for string function"
    ],
    "Refactors": []
  },
  "1.25.4": {
    "date": "2024-09-18",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "replaces create contract button with request approval when approval is needed"
    ],
    "Refactors": []
  },
  "1.25.3": {
    "date": "2024-09-18",
    "Features": [],
    "Bug Fixes": [
      "fixed white screen when deal does not contain products or dates"
    ],
    "Style": [],
    "Refactors": []
  },
  "1.25.2": {
    "date": "2024-09-18",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "create menu, user photo, and toggle theme moved to left navigation bar",
      "new style for toolbar and appbar in grobotic"
    ],
    "Refactors": []
  },
  "1.25.1": {
    "date": "2024-09-18",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "scrollbars now appear for content instead of the whole page in details pages"
    ],
    "Refactors": []
  },
  "1.25.0": {
    "date": "2024-09-17",
    "Features": [
      "strategy tab updated and added to every deal"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "1.24.7": {
    "date": "2024-09-17",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "added contracted by column to deals"
    ],
    "Refactors": []
  },
  "1.24.6": {
    "date": "2024-09-17",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "revised create deal popup for more efficient styling"
    ],
    "Refactors": []
  },
  "1.24.5": {
    "date": "2024-09-17",
    "Features": [],
    "Bug Fixes": [
      "fixed vertical type error for deals",
      "monthly totals should now be adding up correctly"
    ],
    "Style": [],
    "Refactors": []
  },
  "1.24.4": {
    "date": "2024-09-16",
    "Features": [],
    "Bug Fixes": [
      "fixed calculations for totals inside created deals and during creation"
    ],
    "Style": [],
    "Refactors": []
  },
  "1.24.3": {
    "date": "2024-09-16",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "grid search bar filter count added"
    ],
    "Refactors": []
  },
  "1.24.2": {
    "date": "2024-09-16",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "small border around filter menu and aligned contents"
    ],
    "Refactors": []
  },
  "1.24.1": {
    "date": "2024-09-16",
    "Features": [],
    "Bug Fixes": [
      "added does not contain to the filters list"
    ],
    "Style": [],
    "Refactors": []
  },
  "1.24.0": {
    "date": "2024-09-16",
    "Features": [
      "filters no longer clear on refresh or navigation to another page, the clear filters button will clear the current filters on the active grid"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "1.23.0": {
    "date": "2024-09-13",
    "Features": [
      "strategy tab added with campaign selection for auto filling values in select fields"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "1.22.0": {
    "date": "2024-09-13",
    "Features": [
      "Insertion orders now have a quantity column that will autofill based on the range of dates input into the contract. The contract in pandadoc will accurately display the total for the insertion order whether products are separated by month or set with a range of dates"
    ],
    "Bug Fixes": [
      "key error fixes and interactive components"
    ],
    "Style": [],
    "Refactors": []
  },
  "1.21.0": {
    "date": "2024-09-12",
    "Features": [
      "IO types now display the correct total and set the correct total for contracts and rendering"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "1.20.2": {
    "date": "2024-09-12",
    "Features": [],
    "Bug Fixes": [
      "fix payment schedule data in contract details for PandaDoc section"
    ],
    "Style": [],
    "Refactors": []
  },
  "1.20.1": {
    "date": "2024-09-11",
    "Features": [],
    "Bug Fixes": [
      "fixed bug with request approval button and added product: Website - Add On to products list"
    ],
    "Style": [],
    "Refactors": []
  },
  "1.20.0": {
    "date": "2024-09-09",
    "Features": [
      "deal status for month to month 30 day notice and active is now available"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "1.19.1": {
    "date": "2024-09-07",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "organization images added to deals grid"
    ],
    "Refactors": []
  },
  "1.19.0": {
    "date": "2024-09-07",
    "Features": [
      "deals will dynamically update based on the deal type selected or the signature checkbox state even after the deal has been created."
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "1.18.2": {
    "date": "2024-09-06",
    "Features": [],
    "Bug Fixes": [
      "deal and organization filters are now working correctly and can be used together ie. filter by status and also type"
    ],
    "Style": [],
    "Refactors": []
  },
  "1.18.1": {
    "date": "2024-09-05",
    "Features": [],
    "Bug Fixes": [
      "when changing deal type the code will correctly determine the stage and status to set and will also add or remove the approval process"
    ],
    "Style": [],
    "Refactors": []
  },
  "1.18.0": {
    "date": "2024-09-05",
    "Features": [
      "deal type can now be edited from all locations in the app"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "1.17.0": {
    "date": "2024-09-04",
    "Features": [
      "if organization does not have a vertical assigned, can update org's vertical from create deal screen"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "1.16.3": {
    "date": "2024-09-04",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "removed lines in details pages and aligned fields more efficiently"
    ],
    "Refactors": []
  },
  "1.16.2": {
    "date": "2024-09-04",
    "Features": [],
    "Bug Fixes": [
      "product prices are correctly auto filling the price column"
    ],
    "Style": [],
    "Refactors": []
  },
  "1.16.1": {
    "date": "2024-09-04",
    "Features": [],
    "Bug Fixes": [
      "added validation to organizations for vertical"
    ],
    "Style": [],
    "Refactors": []
  },
  "1.16.0": {
    "date": "2024-09-03",
    "Features": [
      "notes section added to organizations"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "1.15.3": {
    "date": "2024-09-02",
    "Features": [],
    "Bug Fixes": [
      "_dev data_ fixed timeline for webhooks"
    ],
    "Style": [],
    "Refactors": []
  },
  "1.15.2": {
    "date": "2024-09-02",
    "Features": [],
    "Bug Fixes": [
      "deal owner now properly assigns to deal when creating contract directly through the create deal screen"
    ],
    "Style": [],
    "Refactors": []
  },
  "1.15.1": {
    "date": "2024-08-30",
    "Features": [],
    "Bug Fixes": [
      "fixed prepared by not showing up the correct name, and fixed needing to refresh deals grid after creating new deal"
    ],
    "Style": [],
    "Refactors": []
  },
  "1.15.0": {
    "date": "2024-08-29",
    "Features": [
      "invoicing for CSA now properly calculates the separate payments based on the number of payments selected"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "1.14.0": {
    "date": "2024-08-29",
    "Features": [
      "contact photos and emails are now displayed when selecting contacts while creating organizations"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "1.13.0": {
    "date": "2024-08-29",
    "Features": [
      "deals and contract now show contracted by organization"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "1.12.0": {
    "date": "2024-08-29",
    "Features": [
      "deals kanban now contains links to deal by clicking on deal name"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "1.11.7": {
    "date": "2024-08-28",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "adjusted review deal page for responsiveness to smaller screens"
    ],
    "Refactors": []
  },
  "1.11.6": {
    "date": "2024-08-28",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "added smaller loader for details pages"
    ],
    "Refactors": []
  },
  "1.11.5": {
    "date": "2024-08-28",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "further improved performance with optimized queries"
    ]
  },
  "1.11.4": {
    "date": "2024-08-28",
    "Features": [],
    "Bug Fixes": [
      "approval process should update now if hitting back in create deal to change the deal type",
      "contracted by is now displayed in the contract for each deal when editing"
    ],
    "Style": [],
    "Refactors": [
      "improve fetching performance by optimizing data fetching and query handling"
    ]
  },
  "1.11.3": {
    "date": "2024-08-27",
    "Features": [],
    "Bug Fixes": [
      "approval process should update now if hitting back in create deal to change the deal type"
    ],
    "Style": [],
    "Refactors": []
  },
  "1.11.2": {
    "date": "2024-08-27",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "improve fetching performance by optimizing data fetching and query handling"
    ]
  },
  "1.11.1": {
    "date": "2024-08-27",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": [
      "**api:** optimize data fetching and query handling"
    ]
  },
  "1.11.0": {
    "date": "2024-08-27",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "1.10.0": {
    "date": "2024-08-27",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "can access rich text field in light and dark mode",
      "formatted reviewdeal descriptions with rich text"
    ],
    "Refactors": []
  },
  "1.9.0": {
    "date": "2024-08-27",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "can access rich text field in light and dark mode"
    ],
    "Refactors": []
  },
  "1.8.2": {
    "date": "2024-08-23",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "added description to review deal rendered products"
    ],
    "Refactors": []
  },
  "1.8.1": {
    "date": "2024-08-23",
    "Features": [],
    "Bug Fixes": [],
    "Style": [
      "new broadcast message for deal won notifications"
    ],
    "Refactors": []
  },
  "1.8.0": {
    "date": "2024-08-23",
    "Features": [
      "notifications for deal won"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "1.7.1": {
    "date": "2024-08-22",
    "Features": [],
    "Bug Fixes": [
      "organization names can now be edited"
    ],
    "Style": [],
    "Refactors": []
  },
  "1.7.0": {
    "date": "2024-08-22",
    "Features": [
      "new tab in deals for invoicing to display cost per month"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "1.6.2": {
    "date": "2024-08-22",
    "Features": [],
    "Bug Fixes": [
      "can create insertion orders without approval and removed approval tooltip when deal type is IO",
      "csa contracts now correctly using the number of payments to calculate payment schedule used for contract"
    ],
    "Style": [],
    "Refactors": []
  },
  "1.6.1": {
    "date": "2024-08-22",
    "Features": [],
    "Bug Fixes": [
      "link to pandadoc contract now available inside deal via pandadoc icon"
    ],
    "Style": [],
    "Refactors": []
  },
  "1.6.0": {
    "date": "2024-08-21",
    "Features": [
      "updating websites will now not only update the website, but add the current organizations active social profiles and cms used automatically"
    ],
    "Bug Fixes": [
      "active days removed from contract template",
      "new format for website urls",
      "no longer will get white screen when editing organizations that do not contain a vertical"
    ],
    "Style": [],
    "Refactors": []
  },
  "1.5.0": {
    "date": "2024-08-20",
    "Features": [
      "ctrl+f or cmd+f to focus grid toolbar quick filter search component"
    ],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  },
  "1.4.6": {
    "date": "2024-08-20",
    "Features": [],
    "Bug Fixes": [
      "fixed websites not upating when editing organizations information"
    ],
    "Style": [],
    "Refactors": []
  },
  "1.4.5": {
    "date": "2024-08-20",
    "Features": [],
    "Bug Fixes": [
      "payer and accountUsed will now correctly stay as the values selected"
    ],
    "Style": [],
    "Refactors": []
  },
  "1.4.4": {
    "date": "2024-08-20",
    "Features": [],
    "Bug Fixes": [
      "added version control automation to changelog and display"
    ],
    "Style": [],
    "Refactors": []
  },
  "1.4.3": {
    "date": "2024-08-20",
    "Features": [],
    "Bug Fixes": [
      "youtube advertising now enables payer and account fields upon selection"
    ],
    "Style": [],
    "Refactors": []
  },
  "1.4.2": {
    "date": "2024-08-20",
    "Features": [],
    "Bug Fixes": [
      "broadcast message displayed for information"
    ],
    "Style": [],
    "Refactors": []
  },
  "1.4.1": {
    "date": "2024-08-20",
    "Features": [],
    "Bug Fixes": [],
    "Style": [],
    "Refactors": []
  }
};
